import { CobMeta } from './cob-meta';
import { defaults } from 'lodash';

export enum ArgentinaPeopleSolutionsClassOfBusinessId {
  Fee = 2873,
  PersonalAccident = 2874,
  GroupPersonalAccident = 2875,
  WorkersCompensation = 2876,
  TravelLeisureBenefits = 2877,
  NonAdvicePensionsConsultancy = 2878,
  PrivateMedicalInsurance = 2879,
  Funeral = 2880,
  GroupLifeAssurance = 2881,
  TravelBusinessBenefits = 2882,
  GroupIncomeProtection = 2883,
  Dental = 2884,
  Pharmacists = 2885,
  GroupCriticalIllness = 2886,
  CommunicationsBenefits = 2887,
  PersonalAccidentTravel = 2888,
}

export enum ArgentinaPncClassOfBusinessId {
  AviationLiability = 2394,
  MotorPrivateCar = 2395,
  BankersBlanketBond = 2396,
  MarineHull = 2397,
  Bonds = 2398,
  HomeAndMotorPortfolio = 2399,
  CommercialCombined = 2400,
  TradeCreditInsurance = 2401,
  FidelityGuaranteeEmployee = 2402,
  AgriculturalProperty = 2403,
  Fire = 2404,
  Cargo = 2405,
  Motorcycle = 2406,
  PublicProductsLiability = 2407,
  MedicalMalpractice = 2408,
  ProfessionalIndemnityEO = 2409,
  PropertyOwnersLiability = 2410,
  Crime = 2411,
  Computers = 2412,
  MaterialDamageAndBusinessInt = 2413,
  ConstructionCombined = 2414,
  EquipmentPhysicalDamage = 2415,
  FineArtsInsurance = 2416,
  EventInsurance = 2417,
  Terrorism = 2418,
  PropertyDamage = 2419,
  CombinedLiability = 2420,
  DirectorsOfficersLiability = 2421,
  EnvironmentalImpairmentLiab = 2422,
  CyberLiability = 2423,
  WarehouseKeepersLiability = 2424,
  MarinaOperatorsLiability = 2425,
  EmployersLiability = 2426,
  MarineHullLiability = 2427,
  ProductsLiability = 2428,
  ProfIndtyInsuranceBrokers = 2429,
  ProfIndtyFinancialServices = 2430,
  ClinicalTrials = 2431,
  ProfIndtyEngineers = 2432,
  MotorLiability = 2433,
  MotorFleet = 2434,
  MarineLiability = 2435,
  FreightForwardersLiability = 2436,
  ContractualFinancialLoss = 2437,
  LossOfAnticipatedRentalIncome = 2438,
  Livestock = 2439,
  MarinePortPackage = 2440,
  AircraftHull = 2441,
  AircraftHullWar = 2442,
  AviationHangarKeepersLiability = 2443,
  AirportLiability = 2444,
  AssetAllRisk = 2445,
  EnergyProperty = 2446,
  EnergyLiability = 2447,
  ProfIndtySolicitors = 2448,
  Fee = 2449,
  AircraftHullLiability = 2450,
  ContractorsPlantAndEquipment = 2451,
  ExcessLiability = 2452,
  MotorCommercialVehicle = 2453,
  MotorSpecialTypes = 2454,
  PropertyOwnersCombined = 2455,
  EngineeringMachineryBreakdown = 2456,
  Engineering = 2457,
  ArmoredCarTransitRisks = 2458,
  ContractFrustrationNonPayment = 2459,
  ContractorsAllRisks = 2460,
  LossOfProfits = 2461,
  ErectionAllRisks = 2462,
}

export enum BrazilPeopleSolutionsClassOfBusinessId {
  TravelBusinessBenefits = 2889,
  GroupIncomeProtection = 2890,
  GroupPersonalAccident = 2891,
  GroupLifeAssurance = 2892,
  NonAdvicePensionsConsultancy = 2893,
  TravelLeisureBenefits = 2894,
  PersonalAccident = 2895,
  PrivateMedicalInsurance = 2896,
  Dental = 2897,
  Pharmacists = 2898,
  GroupCriticalIllness = 2899,
  CommunicationsBenefits = 2900,
  Fee = 2901,
  PersonalAccidentTravel = 2902,
  Funeral = 2926,
}

export enum BrazilPncClassOfBusinessId {
  HomeAndMotorPortfolio = 2463,
  CommercialCombined = 2464,
  ConstructionCombined = 2465,
  Computers = 2466,
  Crime = 2467,
  EquipmentPhysicalDamage = 2468,
  FineArtsInsurance = 2469,
  EventInsurance = 2470,
  FidelityGuaranteeEmployee = 2471,
  MotorPrivateCar = 2472,
  Terrorism = 2473,
  PropertyDamage = 2474,
  CombinedLiability = 2475,
  DirectorsOfficersLiability = 2476,
  EnvironmentalImpairmentLiab = 2477,
  CyberLiability = 2478,
  PropertyOwnersLiability = 2479,
  WarehouseKeepersLiability = 2480,
  MarinaOperatorsLiability = 2481,
  EmployersLiability = 2482,
  MarineHullLiability = 2483,
  PublicProductsLiability = 2484,
  ProductsLiability = 2485,
  ProfIndtyInsuranceBrokers = 2486,
  ProfIndtyFinancialServices = 2487,
  ClinicalTrials = 2488,
  ProfessionalIndemnityEO = 2489,
  ProfIndtyEngineers = 2490,
  MotorLiability = 2491,
  MotorFleet = 2492,
  Cargo = 2493,
  MarineLiability = 2494,
  FreightForwardersLiability = 2495,
  ContractualFinancialLoss = 2496,
  LossOfAnticipatedRentalIncome = 2497,
  TradeCreditInsurance = 2498,
  Bonds = 2499,
  AgriculturalProperty = 2500,
  Livestock = 2501,
  MarinePortPackage = 2502,
  MarineHull = 2503,
  AviationLiability = 2504,
  AircraftHull = 2505,
  AircraftHullWar = 2506,
  AviationHangarKeepersLiability = 2507,
  AirportLiability = 2508,
  AssetAllRisk = 2509,
  EnergyProperty = 2510,
  EnergyLiability = 2511,
  MedicalMalpractice = 2512,
  ProfIndtySolicitors = 2513,
  BankersBlanketBond = 2514,
  Fee = 2515,
  Fire = 2516,
  Motorcycle = 2517,
  MaterialDamageAndBusinessInt = 2518,
  AircraftHullLiability = 2519,
  ContractorsPlantAndEquipment = 2520,
  ExcessLiability = 2521,
  MotorCommercialVehicle = 2522,
  MotorSpecialTypes = 2523,
  PropertyOwnersCombined = 2524,
  EngineeringMachineryBreakdown = 2525,
  Engineering = 2526,
  ArmoredCarTransitRisks = 2527,
  ContractFrustrationNonPayment = 2528,
  ContractorsAllRisks = 2529,
  ErectionAllRisks = 2530,
  LossOfProfits = 2531,
}

export enum ChilePeopleSolutionsClassOfBusinessId {
  PersonalAccident = 2903,
  TravelBusinessBenefits = 2904,
  PrivateMedicalInsurance = 2905,
  Fee = 2906,
  GroupLifeAssurance = 2907,
  GroupPersonalAccident = 2908,
  TravelLeisureBenefits = 2909,
  NonAdvicePensionsConsultancy = 2910,
  GroupIncomeProtection = 2911,
  Dental = 2912,
  Pharmacists = 2913,
  GroupCriticalIllness = 2914,
  CommunicationsBenefits = 2915,
  PersonalAccidentTravel = 2916,
}

export enum ChilePncClassOfBusinessId {
  MotorPrivateCar = 2532,
  BankersBlanketBond = 2533,
  AircraftHull = 2534,
  AircraftHullLiability = 2535,
  MarineHull = 2536,
  MarinePortPackage = 2537,
  TradeCreditInsurance = 2538,
  CyberLiability = 2539,
  DirectorsOfficersLiability = 2540,
  ProfessionalIndemnityEO = 2541,
  ContractorsPlantAndEquipment = 2542,
  Computers = 2543,
  EquipmentPhysicalDamage = 2544,
  FidelityGuaranteeEmployee = 2545,
  Bonds = 2546,
  Cargo = 2547,
  Fire = 2548,
  AgriculturalProperty = 2549,
  HomeAndMotorPortfolio = 2550,
  AssetAllRisk = 2551,
  Motorcycle = 2552,
  FineArtsInsurance = 2553,
  PropertyDamage = 2554,
  PublicProductsLiability = 2555,
  EnvironmentalImpairmentLiab = 2556,
  ExcessLiability = 2557,
  ProductsLiability = 2558,
  MarineLiability = 2559,
  ProfIndtyInsuranceBrokers = 2560,
  Crime = 2561,
  Terrorism = 2562,
  ConstructionCombined = 2563,
  MaterialDamageAndBusinessInt = 2564,
  MotorCommercialVehicle = 2565,
  MotorSpecialTypes = 2566,
  AviationLiability = 2567,
  CommercialCombined = 2568,
  MedicalMalpractice = 2569,
  PropertyOwnersLiability = 2570,
  EventInsurance = 2571,
  CombinedLiability = 2572,
  WarehouseKeepersLiability = 2573,
  MarinaOperatorsLiability = 2574,
  EmployersLiability = 2575,
  MarineHullLiability = 2576,
  ProfIndtyFinancialServices = 2577,
  ClinicalTrials = 2578,
  ProfIndtyEngineers = 2579,
  MotorLiability = 2580,
  MotorFleet = 2581,
  FreightForwardersLiability = 2582,
  ContractualFinancialLoss = 2583,
  LossOfAnticipatedRentalIncome = 2584,
  Livestock = 2585,
  AircraftHullWar = 2586,
  AviationHangarKeepersLiability = 2587,
  AirportLiability = 2588,
  EnergyProperty = 2589,
  EnergyLiability = 2590,
  ProfIndtySolicitors = 2591,
  Fee = 2592,
  PropertyOwnersCombined = 2593,
  EngineeringMachineryBreakdown = 2594,
  Engineering = 2595,
  ArmoredCarTransitRisks = 2596,
  ContractFrustrationNonPayment = 2597,
  ContractorsAllRisks = 2598,
  ErectionAllRisks = 2599,
}

export enum ColombiaPeopleSolutionsClassOfBusinessId {
  PersonalAccident = 2917,
  PersonalAccidentTravel = 2918,
  TravelLeisureBenefits = 2919,
  PrivateMedicalInsurance = 2920,
  GroupCriticalIllness = 2921,
  GroupLifeAssurance = 2922,
  Fee = 2923,
  Dental = 2924,
  Funeral = 2925,
  GroupIncomeProtection = 2927,
  GroupPersonalAccident = 2928,
  NonAdvicePensionsConsultancy = 2929,
  TravelBusinessBenefits = 2930,
  Pharmacists = 2931,
  CommunicationsBenefits = 2932,
  WorkersCompensation = 2933,
}

export enum ColombiaPncClassOfBusinessId {
  AgriculturalProperty = 2600,
  ContractualFinancialLoss = 2601,
  MotorPrivateCar = 2602,
  MotorFleet = 2603,
  Motorcycle = 2604,
  MotorSpecialTypes = 2605,
  AircraftHull = 2606,
  BankersBlanketBond = 2607,
  AssetAllRisk = 2608,
  MarineHull = 2609,
  PropertyOwnersCombined = 2610,
  Bonds = 2611,
  CyberLiability = 2612,
  DirectorsOfficersLiability = 2613,
  Computers = 2614,
  FidelityGuaranteeEmployee = 2615,
  Fire = 2616,
  HomeAndMotorPortfolio = 2617,
  LossOfProfits = 2618,
  Livestock = 2619,
  CommercialCombined = 2620,
  EnvironmentalImpairmentLiab = 2621,
  PublicProductsLiability = 2622,
  MedicalMalpractice = 2623,
  ProfessionalIndemnityEO = 2624,
  EngineeringMachineryBreakdown = 2625,
  TradeCreditInsurance = 2626,
  MotorLiability = 2627,
  Crime = 2628,
  ConstructionCombined = 2629,
  PropertyDamage = 2630,
  Engineering = 2631,
  ArmoredCarTransitRisks = 2632,
  Cargo = 2633,
  AviationLiability = 2634,
  PropertyOwnersLiability = 2635,
  MaterialDamageAndBusinessInt = 2636,
  EquipmentPhysicalDamage = 2637,
  FineArtsInsurance = 2638,
  EventInsurance = 2639,
  Terrorism = 2640,
  CombinedLiability = 2641,
  WarehouseKeepersLiability = 2642,
  MarinaOperatorsLiability = 2643,
  EmployersLiability = 2644,
  MarineHullLiability = 2645,
  ProductsLiability = 2646,
  ProfIndtyInsuranceBrokers = 2647,
  ProfIndtyFinancialServices = 2648,
  ClinicalTrials = 2649,
  ProfIndtyEngineers = 2650,
  MarineLiability = 2651,
  FreightForwardersLiability = 2652,
  LossOfAnticipatedRentalIncome = 2653,
  MarinePortPackage = 2654,
  AircraftHullWar = 2655,
  AviationHangarKeepersLiability = 2656,
  AirportLiability = 2657,
  EnergyProperty = 2658,
  EnergyLiability = 2659,
  ProfIndtySolicitors = 2660,
  Fee = 2661,
  AircraftHullLiability = 2662,
  ContractorsPlantAndEquipment = 2663,
  ExcessLiability = 2664,
  MotorCommercialVehicle = 2665,
  ContractFrustrationNonPayment = 2666,
  ContractorsAllRisks = 2667,
  ErectionAllRisks = 2668,
}

export enum MexicoPeopleSolutionsClassOfBusinessId {
  PrivateMedicalInsurance = 2934,
  GroupLifeAssurance = 2935,
  GroupPersonalAccident = 2936,
  Fee = 2937,
  GroupCriticalIllness = 2938,
  PersonalAccident = 2939,
  TravelLeisureBenefits = 2940,
  NonAdvicePensionsConsultancy = 2941,
  TravelBusinessBenefits = 2942,
  GroupIncomeProtection = 2943,
  Dental = 2944,
  Pharmacists = 2945,
  CommunicationsBenefits = 2946,
  PersonalAccidentTravel = 2947,
}

export enum MexicoPncClassOfBusinessId {
  HomeAndMotorPortfolio = 2669,
  MotorFleet = 2670,
  MotorSpecialTypes = 2671,
  Motorcycle = 2672,
  CommercialCombined = 2673,
  AssetAllRisk = 2674,
  Cargo = 2675,
  Fire = 2676,
  MarineHull = 2677,
  PublicProductsLiability = 2678,
  Fee = 2679,
  Terrorism = 2680,
  FidelityGuaranteeEmployee = 2681,
  TradeCreditInsurance = 2682,
  Bonds = 2683,
  BankersBlanketBond = 2684,
  CyberLiability = 2685,
  DirectorsOfficersLiability = 2686,
  PropertyOwnersLiability = 2687,
  AviationLiability = 2688,
  MotorPrivateCar = 2689,
  AgriculturalProperty = 2690,
  MedicalMalpractice = 2691,
  ProfessionalIndemnityEO = 2692,
  Crime = 2693,
  Computers = 2694,
  MaterialDamageAndBusinessInt = 2695,
  ConstructionCombined = 2696,
  EquipmentPhysicalDamage = 2697,
  FineArtsInsurance = 2698,
  EventInsurance = 2699,
  PropertyDamage = 2700,
  CombinedLiability = 2701,
  EnvironmentalImpairmentLiab = 2702,
  WarehouseKeepersLiability = 2703,
  MarinaOperatorsLiability = 2704,
  EmployersLiability = 2705,
  MarineHullLiability = 2706,
  ProductsLiability = 2707,
  ProfIndtyInsuranceBrokers = 2708,
  ProfIndtyFinancialServices = 2709,
  ClinicalTrials = 2710,
  ProfIndtyEngineers = 2711,
  MotorLiability = 2712,
  MarineLiability = 2713,
  FreightForwardersLiability = 2714,
  ContractualFinancialLoss = 2715,
  LossOfAnticipatedRentalIncome = 2716,
  Livestock = 2717,
  MarinePortPackage = 2718,
  AircraftHull = 2719,
  AircraftHullWar = 2720,
  AviationHangarKeepersLiability = 2721,
  AirportLiability = 2722,
  EnergyProperty = 2723,
  EnergyLiability = 2724,
  ProfIndtySolicitors = 2725,
  AircraftHullLiability = 2726,
  ContractorsPlantAndEquipment = 2727,
  ExcessLiability = 2728,
  MotorCommercialVehicle = 2729,
  PropertyOwnersCombined = 2730,
  EngineeringMachineryBreakdown = 2731,
  Engineering = 2732,
  ArmoredCarTransitRisks = 2733,
  ContractFrustrationNonPayment = 2734,
  ContractorsAllRisks = 2735,
  ErectionAllRisks = 2736,
}

export enum PeruPeopleSolutionsClassOfBusinessId {
  PersonalAccident = 2948,
  PrivateMedicalInsurance = 2949,
  GroupCriticalIllness = 2950,
  WorkersCompensation = 2951,
  GroupLifeAssurance = 2952,
  GroupPersonalAccident = 2953,
  TravelLeisureBenefits = 2954,
  NonAdvicePensionsConsultancy = 2955,
  Fee = 2956,
  TravelBusinessBenefits = 2957,
  GroupIncomeProtection = 2958,
  Dental = 2959,
  Pharmacists = 2960,
  CommunicationsBenefits = 2961,
  PersonalAccidentTravel = 2962,
}

export enum PeruPncClassOfBusinessId {
  BankersBlanketBond = 2737,
  FidelityGuaranteeEmployee = 2738,
  AircraftHull = 2739,
  MotorLiability = 2740,
  MarineHull = 2741,
  Bonds = 2742,
  CyberLiability = 2743,
  ContractFrustrationNonPayment = 2744,
  HomeAndMotorPortfolio = 2745,
  Fee = 2746,
  Fire = 2747,
  CommercialCombined = 2748,
  PublicProductsLiability = 2749,
  Crime = 2750,
  ContractorsAllRisks = 2751,
  Computers = 2752,
  ErectionAllRisks = 2753,
  Cargo = 2754,
  MotorPrivateCar = 2755,
  AviationLiability = 2756,
  TradeCreditInsurance = 2757,
  AgriculturalProperty = 2758,
  Motorcycle = 2759,
  MedicalMalpractice = 2760,
  ProfessionalIndemnityEO = 2761,
  PropertyOwnersLiability = 2762,
  MaterialDamageAndBusinessInt = 2763,
  ConstructionCombined = 2764,
  EquipmentPhysicalDamage = 2765,
  FineArtsInsurance = 2766,
  EventInsurance = 2767,
  Terrorism = 2768,
  PropertyDamage = 2769,
  CombinedLiability = 2770,
  DirectorsOfficersLiability = 2771,
  EnvironmentalImpairmentLiab = 2772,
  WarehouseKeepersLiability = 2773,
  MarinaOperatorsLiability = 2774,
  EmployersLiability = 2775,
  MarineHullLiability = 2776,
  ProductsLiability = 2777,
  ProfIndtyInsuranceBrokers = 2778,
  ProfIndtyFinancialServices = 2779,
  ClinicalTrials = 2780,
  ProfIndtyEngineers = 2781,
  MotorFleet = 2782,
  MarineLiability = 2783,
  FreightForwardersLiability = 2784,
  ContractualFinancialLoss = 2785,
  LossOfAnticipatedRentalIncome = 2786,
  Livestock = 2787,
  MarinePortPackage = 2788,
  AircraftHullWar = 2789,
  AviationHangarKeepersLiability = 2790,
  AirportLiability = 2791,
  AssetAllRisk = 2792,
  EnergyProperty = 2793,
  EnergyLiability = 2794,
  ProfIndtySolicitors = 2795,
  AircraftHullLiability = 2796,
  ContractorsPlantAndEquipment = 2797,
  ExcessLiability = 2798,
  MotorCommercialVehicle = 2799,
  MotorSpecialTypes = 2800,
  PropertyOwnersCombined = 2801,
  EngineeringMachineryBreakdown = 2802,
  Engineering = 2803,
  ArmoredCarTransitRisks = 2804,
}

export enum UruguayPeopleSolutionsClassOfBusinessId {
  WorkersCompensation = 2963,
  PersonalAccident = 2964,
  Fee = 2965,
  PrivateMedicalInsurance = 2966,
  GroupLifeAssurance = 2967,
  GroupPersonalAccident = 2968,
  TravelLeisureBenefits = 2969,
  NonAdvicePensionsConsultancy = 2970,
  TravelBusinessBenefits = 2971,
  GroupIncomeProtection = 2972,
  Dental = 2973,
  Pharmacists = 2974,
  GroupCriticalIllness = 2975,
  CommunicationsBenefits = 2976,
  PersonalAccidentTravel = 2977,
}

export enum UruguayPncClassOfBusinessId {
  AgriculturalProperty = 2805,
  MarineHull = 2806,
  CommercialCombined = 2807,
  TradeCreditInsurance = 2808,
  Bonds = 2809,
  Fire = 2810,
  PublicProductsLiability = 2811,
  MotorLiability = 2812,
  Cargo = 2813,
  MotorPrivateCar = 2814,
  HomeAndMotorPortfolio = 2815,
  AviationLiability = 2816,
  FidelityGuaranteeEmployee = 2817,
  Motorcycle = 2818,
  MedicalMalpractice = 2819,
  ProfessionalIndemnityEO = 2820,
  PropertyOwnersLiability = 2821,
  Crime = 2822,
  Computers = 2823,
  MaterialDamageAndBusinessInt = 2824,
  BankersBlanketBond = 2825,
  ConstructionCombined = 2826,
  EquipmentPhysicalDamage = 2827,
  FineArtsInsurance = 2828,
  EventInsurance = 2829,
  Terrorism = 2830,
  PropertyDamage = 2831,
  CombinedLiability = 2832,
  DirectorsOfficersLiability = 2833,
  EnvironmentalImpairmentLiab = 2834,
  CyberLiability = 2835,
  WarehouseKeepersLiability = 2836,
  MarinaOperatorsLiability = 2837,
  EmployersLiability = 2838,
  MarineHullLiability = 2839,
  ProductsLiability = 2840,
  ProfIndtyInsuranceBrokers = 2841,
  ProfIndtyFinancialServices = 2842,
  ClinicalTrials = 2843,
  ProfIndtyEngineers = 2844,
  MotorFleet = 2845,
  MarineLiability = 2846,
  FreightForwardersLiability = 2847,
  ContractualFinancialLoss = 2848,
  LossOfAnticipatedRentalIncome = 2849,
  Livestock = 2850,
  MarinePortPackage = 2851,
  AircraftHull = 2852,
  AircraftHullWar = 2853,
  AviationHangarKeepersLiability = 2854,
  AirportLiability = 2855,
  AssetAllRisk = 2856,
  EnergyProperty = 2857,
  EnergyLiability = 2858,
  ProfIndtySolicitors = 2859,
  Fee = 2860,
  AircraftHullLiability = 2861,
  ContractorsPlantAndEquipment = 2862,
  ExcessLiability = 2863,
  MotorCommercialVehicle = 2864,
  MotorSpecialTypes = 2865,
  PropertyOwnersCombined = 2866,
  EngineeringMachineryBreakdown = 2867,
  Engineering = 2868,
  ArmoredCarTransitRisks = 2869,
  ContractFrustrationNonPayment = 2870,
  ContractorsAllRisks = 2871,
  ErectionAllRisks = 2872,
}

export type ClassOfBusinessId =
  | ArgentinaPeopleSolutionsClassOfBusinessId
  | ArgentinaPncClassOfBusinessId
  | BrazilPeopleSolutionsClassOfBusinessId
  | BrazilPncClassOfBusinessId
  | ChilePeopleSolutionsClassOfBusinessId
  | ChilePncClassOfBusinessId
  | ColombiaPeopleSolutionsClassOfBusinessId
  | ColombiaPncClassOfBusinessId
  | MexicoPeopleSolutionsClassOfBusinessId
  | MexicoPncClassOfBusinessId
  | PeruPeopleSolutionsClassOfBusinessId
  | PeruPncClassOfBusinessId
  | UruguayPeopleSolutionsClassOfBusinessId
  | UruguayPncClassOfBusinessId;

export const ARGENTINA_PEOPLE_SOLUTIONS_COB_META_DATA: Record<
  ArgentinaPeopleSolutionsClassOfBusinessId,
  CobMeta
> = {
  [ArgentinaPeopleSolutionsClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.PersonalAccident]: {
    id: 'personal-accident',
    title: $localize`:@@cob-454:Personal Accident`,
    icon: 'product_thin',
    color: 'green',
    code: '454',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.GroupPersonalAccident]: {
    id: 'group-personal-accident',
    title: $localize`:@@cob-452:Group Personal Accident`,
    icon: 'product_thin',
    color: 'red',
    code: '452',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.WorkersCompensation]: {
    id: 'workers-compensation',
    title: $localize`:@@cob-WCA:Workers Compensation`,
    icon: 'product_thin',
    color: 'green',
    code: 'WCA',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.TravelLeisureBenefits]: {
    id: 'travel-leisure-benefits',
    title: $localize`:@@cob-727:Travel Leisure (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '727',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.NonAdvicePensionsConsultancy]: {
    id: 'non-advice-pensions-consultancy',
    title: $localize`:@@cob-598:Non-Advice Pensions Consultancy`,
    icon: 'product_thin',
    color: 'red',
    code: '598',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.PrivateMedicalInsurance]: {
    id: 'private-medical-insurance',
    title: $localize`:@@cob-625:Private Medical Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '625',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.Funeral]: {
    id: 'funeral',
    title: $localize`:@@cob-595:Funeral`,
    icon: 'product_thin',
    color: 'pink',
    code: '595',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.GroupLifeAssurance]: {
    id: 'group-life-assurance',
    title: $localize`:@@cob-640:Group Life Assurance`,
    icon: 'product_thin',
    color: 'red',
    code: '640',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.TravelBusinessBenefits]: {
    id: 'travel-business-benefits',
    title: $localize`:@@cob-728:Travel Business (Benefits)`,
    icon: 'product_thin',
    color: 'pink',
    code: '728',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.GroupIncomeProtection]: {
    id: 'group-income-protection',
    title: $localize`:@@cob-262:Group Income Protection`,
    icon: 'product_thin',
    color: 'yellow',
    code: '262',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.Dental]: {
    id: 'dental',
    title: $localize`:@@cob-602:Dental`,
    icon: 'product_thin',
    color: 'blue',
    code: '602',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.Pharmacists]: {
    id: 'pharmacists',
    title: $localize`:@@cob-441:Pharmacists`,
    icon: 'product_thin',
    color: 'green',
    code: '441',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.GroupCriticalIllness]: {
    id: 'group-critical-illness',
    title: $localize`:@@cob-699:Group Critical Illness`,
    icon: 'product_thin',
    color: 'orange',
    code: '699',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.CommunicationsBenefits]: {
    id: 'communications-benefits',
    title: $localize`:@@cob-446:Communications (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '446',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPeopleSolutionsClassOfBusinessId.PersonalAccidentTravel]: {
    id: 'personal-accident-travel',
    title: $localize`:@@cob-456:Personal Accident & Travel`,
    icon: 'product_thin',
    color: 'green',
    code: '456',
    type: 'policy',
    misc: {
      department: 'Argentina People Solutions',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
};

export const ARGENTINA_PNC_COB_META_DATA: Record<
  ArgentinaPncClassOfBusinessId,
  CobMeta
> = {
  [ArgentinaPncClassOfBusinessId.AviationLiability]: {
    id: 'aviation-liability',
    title: $localize`:@@cob-503:Aviation Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '503',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MotorPrivateCar]: {
    id: 'motor-private-car',
    title: $localize`:@@cob-251:Motor Private Car`,
    icon: 'product_thin',
    color: 'red',
    code: '251',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.BankersBlanketBond]: {
    id: 'bankers-blanket-bond',
    title: $localize`:@@cob-BBB:Bankers Blanket Bond`,
    icon: 'product_thin',
    color: 'blue',
    code: 'BBB',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MarineHull]: {
    id: 'marine-hull',
    title: $localize`:@@cob-530:Marine Hull`,
    icon: 'product_thin',
    color: 'pink',
    code: '530',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Bonds]: {
    id: 'bonds',
    title: $localize`:@@cob-404:Bonds`,
    icon: 'product_thin',
    color: 'red',
    code: '404',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.HomeAndMotorPortfolio]: {
    id: 'home-and-motor-portfolio',
    title: $localize`:@@cob-289:Home and Motor Portfolio`,
    icon: 'product_thin',
    color: 'pink',
    code: '289',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.CommercialCombined]: {
    id: 'commercial-combined',
    title: $localize`:@@cob-301:Commercial Combined`,
    icon: 'product_thin',
    color: 'pink',
    code: '301',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.TradeCreditInsurance]: {
    id: 'trade-credit-insurance',
    title: $localize`:@@cob-403:Trade Credit Insurance`,
    icon: 'product_thin',
    color: 'green',
    code: '403',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.FidelityGuaranteeEmployee]: {
    id: 'fidelity-guarantee-employee',
    title: $localize`:@@cob-402:Fidelity Guarantee Employee`,
    icon: 'product_thin',
    color: 'orange',
    code: '402',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.AgriculturalProperty]: {
    id: 'agricultural-property',
    title: $localize`:@@cob-344:Agricultural Property`,
    icon: 'product_thin',
    color: 'red',
    code: '344',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Fire]: {
    id: 'fire',
    title: $localize`:@@cob-569:FIRE`,
    icon: 'product_thin',
    color: 'blue',
    code: '569',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Cargo]: {
    id: 'cargo',
    title: $localize`:@@cob-529:Cargo`,
    icon: 'product_thin',
    color: 'blue',
    code: '529',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Motorcycle]: {
    id: 'motorcycle',
    title: $localize`:@@cob-252:Motorcycle`,
    icon: 'product_thin',
    color: 'yellow',
    code: '252',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.PublicProductsLiability]: {
    id: 'public-products-liability',
    title: $localize`:@@cob-112:Public & Products Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '112',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MedicalMalpractice]: {
    id: 'medical-malpractice',
    title: $localize`:@@cob-169:Medical Malpractice`,
    icon: 'product_thin',
    color: 'blue',
    code: '169',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ProfessionalIndemnityEO]: {
    id: 'professional-indemnity-e-o',
    title: $localize`:@@cob-175:Professional Indemnity E&O`,
    icon: 'product_thin',
    color: 'blue',
    code: '175',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.PropertyOwnersLiability]: {
    id: 'property-owners-liability',
    title: $localize`:@@cob-155:Property Owners Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: '155',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Crime]: {
    id: 'crime',
    title: $localize`:@@cob-410:Crime`,
    icon: 'product_thin',
    color: 'red',
    code: '410',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Computers]: {
    id: 'computers',
    title: $localize`:@@cob-303:Computers`,
    icon: 'product_thin',
    color: 'blue',
    code: '303',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MaterialDamageAndBusinessInt]: {
    id: 'material-damage-and-business-int',
    title: $localize`:@@cob-333:Material Damage and Business Int`,
    icon: 'product_thin',
    color: 'orange',
    code: '333',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ConstructionCombined]: {
    id: 'construction-combined',
    title: $localize`:@@cob-577:Construction Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '577',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.EquipmentPhysicalDamage]: {
    id: 'equipment-physical-damage',
    title: $localize`:@@cob-219:Equipment Physical Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '219',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.FineArtsInsurance]: {
    id: 'fine-arts-insurance',
    title: $localize`:@@cob-911:Fine Arts Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '911',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.EventInsurance]: {
    id: 'event-insurance',
    title: $localize`:@@cob-415:Event Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '415',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Terrorism]: {
    id: 'terrorism',
    title: $localize`:@@cob-307:Terrorism`,
    icon: 'product_thin',
    color: 'yellow',
    code: '307',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.PropertyDamage]: {
    id: 'property-damage',
    title: $localize`:@@cob-5:Property Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '5',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.CombinedLiability]: {
    id: 'combined-liability',
    title: $localize`:@@cob-116:Combined Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '116',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.DirectorsOfficersLiability]: {
    id: 'directors-officers-liability',
    title: $localize`:@@cob-117:Directors & Officers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '117',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.EnvironmentalImpairmentLiab]: {
    id: 'environmental-impairment-liab',
    title: $localize`:@@cob-152:Environmental Impairment Liab`,
    icon: 'product_thin',
    color: 'red',
    code: '152',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.CyberLiability]: {
    id: 'cyber-liability',
    title: $localize`:@@cob-183:Cyber Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '183',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.WarehouseKeepersLiability]: {
    id: 'warehouse-keepers-liability',
    title: $localize`:@@cob-389:Warehouse Keepers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '389',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MarinaOperatorsLiability]: {
    id: 'marina-operators-liability',
    title: $localize`:@@cob-523:Marina Operators Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '520',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.EmployersLiability]: {
    id: 'employers-liability',
    title: $localize`:@@cob-121:Employers Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '111',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MarineHullLiability]: {
    id: 'marine-hull-liability',
    title: $localize`:@@cob-164:Marine Hull & Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '523',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ProductsLiability]: {
    id: 'products-liability',
    title: $localize`:@@cob-184:Products Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '121',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ProfIndtyInsuranceBrokers]: {
    id: 'prof-indty-insurance-brokers',
    title: $localize`:@@cob-139:Prof Indty Insurance Brokers`,
    icon: 'product_thin',
    color: 'yellow',
    code: '164',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ProfIndtyFinancialServices]: {
    id: 'prof-indty-financial-services',
    title: $localize`:@@cob-184:Prof Indty Financial Services`,
    icon: 'product_thin',
    color: 'orange',
    code: '184',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ClinicalTrials]: {
    id: 'clinical-trials',
    title: $localize`:@@cob-11:Clinical Trials`,
    icon: 'product_thin',
    color: 'orange',
    code: '139',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ProfIndtyEngineers]: {
    id: 'prof-indty-engineers',
    title: $localize`:@@cob-203:Prof Indty Engineers`,
    icon: 'product_thin',
    color: 'green',
    code: '167',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MotorLiability]: {
    id: 'motor-liability',
    title: $localize`:@@cob-527:Motor Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '11',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MotorFleet]: {
    id: 'motor-fleet',
    title: $localize`:@@cob-552:Motor Fleet`,
    icon: 'product_thin',
    color: 'pink',
    code: '203',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MarineLiability]: {
    id: 'marine-liability',
    title: $localize`:@@cob-527:Marine Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '527',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.FreightForwardersLiability]: {
    id: 'freight-forwarders-liability',
    title: $localize`:@@cob-552:Freight Forwarders Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '552',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ContractualFinancialLoss]: {
    id: 'contractual-financial-loss',
    title: $localize`:@@cob-432:Contractual Financial Loss`,
    icon: 'product_thin',
    color: 'orange',
    code: '432',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.LossOfAnticipatedRentalIncome]: {
    id: 'loss-of-anticipated-rental-income',
    title: $localize`:@@cob-360:Loss of Anticipated Rental Income`,
    icon: 'product_thin',
    color: 'yellow',
    code: '360',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Livestock]: {
    id: 'livestock',
    title: $localize`:@@cob-374:Livestock`,
    icon: 'product_thin',
    color: 'red',
    code: '374',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MarinePortPackage]: {
    id: 'marine-port-package',
    title: $localize`:@@cob-486:Marine Port Package`,
    icon: 'product_thin',
    color: 'pink',
    code: '486',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.AircraftHull]: {
    id: 'aircraft-hull',
    title: $localize`:@@cob-501:Aircraft Hull`,
    icon: 'product_thin',
    color: 'yellow',
    code: '501',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.AircraftHullWar]: {
    id: 'aircraft-hull-war',
    title: $localize`:@@cob-HUW:Aircraft Hull War`,
    icon: 'product_thin',
    color: 'green',
    code: 'HUW',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.AviationHangarKeepersLiability]: {
    id: 'aviation-hangar-keepers-liability',
    title: $localize`:@@cob-APH:Aviation Hangar keepers Liability`,
    icon: 'product_thin',
    color: 'red',
    code: 'APH',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.AirportLiability]: {
    id: 'airport-liability',
    title: $localize`:@@cob-ARE:Airport Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: 'ARE',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.AssetAllRisk]: {
    id: 'asset-all-risk',
    title: $localize`:@@cob-334:Asset All Risk`,
    icon: 'product_thin',
    color: 'blue',
    code: '334',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.EnergyProperty]: {
    id: 'energy-property',
    title: $localize`:@@cob-ENPR:Energy Property`,
    icon: 'product_thin',
    color: 'pink',
    code: 'ENPR',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.EnergyLiability]: {
    id: 'energy-liability',
    title: $localize`:@@cob-TPL:Energy Liability`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'TPL',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ProfIndtySolicitors]: {
    id: 'prof-indty-solicitors',
    title: $localize`:@@cob-125:Prof Indty Solicitors`,
    icon: 'product_thin',
    color: 'blue',
    code: '125',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.AircraftHullLiability]: {
    id: 'aircraft-hull-liability',
    title: $localize`:@@cob-AHL:Aircraft Hull & Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'AHL',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ContractorsPlantAndEquipment]: {
    id: 'contractors-plant-and-equipment',
    title: $localize`:@@cob-393:Contractors Plant and Equipment`,
    icon: 'product_thin',
    color: 'blue',
    code: '393',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ExcessLiability]: {
    id: 'excess-liability',
    title: $localize`:@@cob-ELI:Excess Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'ELI',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MotorCommercialVehicle]: {
    id: 'motor-commercial-vehicle',
    title: $localize`:@@cob-202:Motor Commercial Vehicle`,
    icon: 'product_thin',
    color: 'green',
    code: '202',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.MotorSpecialTypes]: {
    id: 'motor-special-types',
    title: $localize`:@@cob-210:Motor Special Types`,
    icon: 'product_thin',
    color: 'yellow',
    code: '210',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.PropertyOwnersCombined]: {
    id: 'property-owners-combined',
    title: $localize`:@@cob-306:Property Owners Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '306',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.EngineeringMachineryBreakdown]: {
    id: 'engineering-machinery-breakdown',
    title: $localize`:@@cob-328:Engineering Machinery Breakdown`,
    icon: 'product_thin',
    color: 'orange',
    code: '328',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.Engineering]: {
    id: 'engineering',
    title: $localize`:@@cob-305:Engineering`,
    icon: 'product_thin',
    color: 'yellow',
    code: '305',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ArmoredCarTransitRisks]: {
    id: 'armored-car-transit-risks',
    title: $localize`:@@cob-ACR:Armored Car Transit Risks`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'ACR',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ContractFrustrationNonPayment]: {
    id: 'contract-frustration-non-payment',
    title: $localize`:@@cob-CFP:Contract Frustration Non Payment`,
    icon: 'product_thin',
    color: 'red',
    code: 'CFP',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ContractorsAllRisks]: {
    id: 'contractors-all-risks',
    title: $localize`:@@cob-316:Contractors All Risks`,
    icon: 'product_thin',
    color: 'green',
    code: '316',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.LossOfProfits]: {
    id: 'loss-of-profits',
    title: $localize`:@@cob-LOP:Loss of Profits`,
    icon: 'product_thin',
    color: 'green',
    code: 'LOP',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
  [ArgentinaPncClassOfBusinessId.ErectionAllRisks]: {
    id: 'erection-all-risks',
    title: $localize`:@@cob-12:Erection All Risks`,
    icon: 'product_thin',
    color: 'orange',
    code: '12',
    type: 'policy',
    misc: {
      department: 'Argentina P&C',
      country: 'Argentina',
      countryCode: 'ARG',
    },
  },
};

export const BRAZIL_PEOPLE_SOLUTIONS_COB_META_DATA: Record<
  BrazilPeopleSolutionsClassOfBusinessId,
  CobMeta
> = {
  [BrazilPeopleSolutionsClassOfBusinessId.TravelBusinessBenefits]: {
    id: 'travel-business-benefits',
    title: $localize`:@@cob-728:Travel Business (Benefits)`,
    icon: 'product_thin',
    color: 'pink',
    code: '728',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.GroupIncomeProtection]: {
    id: 'group-income-protection',
    title: $localize`:@@cob-262:Group Income Protection`,
    icon: 'product_thin',
    color: 'yellow',
    code: '262',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.GroupPersonalAccident]: {
    id: 'group-personal-accident',
    title: $localize`:@@cob-452:Group Personal Accident`,
    icon: 'product_thin',
    color: 'red',
    code: '452',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.GroupLifeAssurance]: {
    id: 'group-life-assurance',
    title: $localize`:@@cob-640:Group Life Assurance`,
    icon: 'product_thin',
    color: 'red',
    code: '640',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.NonAdvicePensionsConsultancy]: {
    id: 'non-advice-pensions-consultancy',
    title: $localize`:@@cob-598:Non-Advice Pensions Consultancy`,
    icon: 'product_thin',
    color: 'red',
    code: '598',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.TravelLeisureBenefits]: {
    id: 'travel-leisure-benefits',
    title: $localize`:@@cob-727:Travel Leisure (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '727',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.PersonalAccident]: {
    id: 'personal-accident',
    title: $localize`:@@cob-454:Personal Accident`,
    icon: 'product_thin',
    color: 'green',
    code: '454',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.PrivateMedicalInsurance]: {
    id: 'private-medical-insurance',
    title: $localize`:@@cob-625:Private Medical Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '625',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.Dental]: {
    id: 'dental',
    title: $localize`:@@cob-602:Dental`,
    icon: 'product_thin',
    color: 'blue',
    code: '602',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.Pharmacists]: {
    id: 'pharmacists',
    title: $localize`:@@cob-441:Pharmacists`,
    icon: 'product_thin',
    color: 'green',
    code: '441',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.GroupCriticalIllness]: {
    id: 'group-critical-illness',
    title: $localize`:@@cob-699:Group Critical Illness`,
    icon: 'product_thin',
    color: 'orange',
    code: '699',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.CommunicationsBenefits]: {
    id: 'communications-benefits',
    title: $localize`:@@cob-446:Communications (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '446',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.PersonalAccidentTravel]: {
    id: 'personal-accident-travel',
    title: $localize`:@@cob-456:Personal Accident & Travel`,
    icon: 'product_thin',
    color: 'green',
    code: '456',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPeopleSolutionsClassOfBusinessId.Funeral]: {
    id: 'funeral',
    title: $localize`:@@cob-595:Funeral`,
    icon: 'product_thin',
    color: 'pink',
    code: '595',
    type: 'policy',
    misc: {
      department: 'Brazil People Solutions',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
};

export const BRAZIL_PNC_COB_META_DATA: Record<
  BrazilPncClassOfBusinessId,
  CobMeta
> = {
  [BrazilPncClassOfBusinessId.HomeAndMotorPortfolio]: {
    id: 'home-and-motor-portfolio',
    title: $localize`:@@cob-289:Home and Motor Portfolio`,
    icon: 'product_thin',
    color: 'pink',
    code: '289',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.CommercialCombined]: {
    id: 'commercial-combined',
    title: $localize`:@@cob-301:Commercial Combined`,
    icon: 'product_thin',
    color: 'pink',
    code: '301',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ConstructionCombined]: {
    id: 'construction-combined',
    title: $localize`:@@cob-577:Construction Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '577',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Computers]: {
    id: 'computers',
    title: $localize`:@@cob-303:Computers`,
    icon: 'product_thin',
    color: 'blue',
    code: '303',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Crime]: {
    id: 'crime',
    title: $localize`:@@cob-410:Crime`,
    icon: 'product_thin',
    color: 'red',
    code: '410',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.EquipmentPhysicalDamage]: {
    id: 'equipment-physical-damage',
    title: $localize`:@@cob-219:Equipment Physical Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '219',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.FineArtsInsurance]: {
    id: 'fine-arts-insurance',
    title: $localize`:@@cob-911:Fine Arts Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '911',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.EventInsurance]: {
    id: 'event-insurance',
    title: $localize`:@@cob-415:Event Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '415',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.FidelityGuaranteeEmployee]: {
    id: 'fidelity-guarantee-employee',
    title: $localize`:@@cob-402:Fidelity Guarantee Employee`,
    icon: 'product_thin',
    color: 'orange',
    code: '402',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MotorPrivateCar]: {
    id: 'motor-private-car',
    title: $localize`:@@cob-251:Motor Private Car`,
    icon: 'product_thin',
    color: 'red',
    code: '251',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Terrorism]: {
    id: 'terrorism',
    title: $localize`:@@cob-307:Terrorism`,
    icon: 'product_thin',
    color: 'yellow',
    code: '307',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.PropertyDamage]: {
    id: 'property-damage',
    title: $localize`:@@cob-5:Property Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '5',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.CombinedLiability]: {
    id: 'combined-liability',
    title: $localize`:@@cob-116:Combined Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '116',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.DirectorsOfficersLiability]: {
    id: 'directors-officers-liability',
    title: $localize`:@@cob-117:Directors & Officers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '117',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.EnvironmentalImpairmentLiab]: {
    id: 'environmental-impairment-liab',
    title: $localize`:@@cob-152:Environmental Impairment Liab`,
    icon: 'product_thin',
    color: 'red',
    code: '152',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.CyberLiability]: {
    id: 'cyber-liability',
    title: $localize`:@@cob-183:Cyber Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '183',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.PropertyOwnersLiability]: {
    id: 'property-owners-liability',
    title: $localize`:@@cob-155:Property Owners Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: '155',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.WarehouseKeepersLiability]: {
    id: 'warehouse-keepers-liability',
    title: $localize`:@@cob-389:Warehouse Keepers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '389',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MarinaOperatorsLiability]: {
    id: 'marina-operators-liability',
    title: $localize`:@@cob-520:Marina Operators Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '520',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.EmployersLiability]: {
    id: 'employers-liability',
    title: $localize`:@@cob-111:Employers Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '111',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MarineHullLiability]: {
    id: 'marine-hull-liability',
    title: $localize`:@@cob-523:Marine Hull & Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '523',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.PublicProductsLiability]: {
    id: 'public-products-liability',
    title: $localize`:@@cob-112:Public & Products Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '112',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ProductsLiability]: {
    id: 'products-liability',
    title: $localize`:@@cob-121:Products Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '121',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ProfIndtyInsuranceBrokers]: {
    id: 'prof-indty-insurance-brokers',
    title: $localize`:@@cob-164:Prof Indty Insurance Brokers`,
    icon: 'product_thin',
    color: 'yellow',
    code: '164',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ProfIndtyFinancialServices]: {
    id: 'prof-indty-financial-services',
    title: $localize`:@@cob-184:Prof Indty Financial Services`,
    icon: 'product_thin',
    color: 'orange',
    code: '184',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ClinicalTrials]: {
    id: 'clinical-trials',
    title: $localize`:@@cob-139:Clinical Trials`,
    icon: 'product_thin',
    color: 'orange',
    code: '139',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ProfessionalIndemnityEO]: {
    id: 'professional-indemnity-e-o',
    title: $localize`:@@cob-175:Professional Indemnity E&O`,
    icon: 'product_thin',
    color: 'blue',
    code: '175',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ProfIndtyEngineers]: {
    id: 'prof-indty-engineers',
    title: $localize`:@@cob-167:Prof Indty Engineers`,
    icon: 'product_thin',
    color: 'green',
    code: '167',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MotorLiability]: {
    id: 'motor-liability',
    title: $localize`:@@cob-11:Motor Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '11',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MotorFleet]: {
    id: 'motor-fleet',
    title: $localize`:@@cob-203:Motor Fleet`,
    icon: 'product_thin',
    color: 'pink',
    code: '203',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Cargo]: {
    id: 'cargo',
    title: $localize`:@@cob-529:Cargo`,
    icon: 'product_thin',
    color: 'blue',
    code: '529',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MarineLiability]: {
    id: 'marine-liability',
    title: $localize`:@@cob-527:Marine Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '527',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.FreightForwardersLiability]: {
    id: 'freight-forwarders-liability',
    title: $localize`:@@cob-552:Freight Forwarders Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '552',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ContractualFinancialLoss]: {
    id: 'contractual-financial-loss',
    title: $localize`:@@cob-432:Contractual Financial Loss`,
    icon: 'product_thin',
    color: 'orange',
    code: '432',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.LossOfAnticipatedRentalIncome]: {
    id: 'loss-of-anticipated-rental-income',
    title: $localize`:@@cob-360:Loss of Anticipated Rental Income`,
    icon: 'product_thin',
    color: 'yellow',
    code: '360',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.TradeCreditInsurance]: {
    id: 'trade-credit-insurance',
    title: $localize`:@@cob-403:Trade Credit Insurance`,
    icon: 'product_thin',
    color: 'green',
    code: '403',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Bonds]: {
    id: 'bonds',
    title: $localize`:@@cob-404:Bonds`,
    icon: 'product_thin',
    color: 'red',
    code: '404',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.AgriculturalProperty]: {
    id: 'agricultural-property',
    title: $localize`:@@cob-344:Agricultural Property`,
    icon: 'product_thin',
    color: 'red',
    code: '344',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Livestock]: {
    id: 'livestock',
    title: $localize`:@@cob-374:Livestock`,
    icon: 'product_thin',
    color: 'red',
    code: '374',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MarinePortPackage]: {
    id: 'marine-port-package',
    title: $localize`:@@cob-486:Marine Port Package`,
    icon: 'product_thin',
    color: 'pink',
    code: '486',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MarineHull]: {
    id: 'marine-hull',
    title: $localize`:@@cob-530:Marine Hull`,
    icon: 'product_thin',
    color: 'pink',
    code: '530',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.AviationLiability]: {
    id: 'aviation-liability',
    title: $localize`:@@cob-503:Aviation Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '503',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.AircraftHull]: {
    id: 'aircraft-hull',
    title: $localize`:@@cob-501:Aircraft Hull`,
    icon: 'product_thin',
    color: 'yellow',
    code: '501',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.AircraftHullWar]: {
    id: 'aircraft-hull-war',
    title: $localize`:@@cob-HUW:Aircraft Hull War`,
    icon: 'product_thin',
    color: 'green',
    code: 'HUW',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.AviationHangarKeepersLiability]: {
    id: 'aviation-hangar-keepers-liability',
    title: $localize`:@@cob-APH:Aviation Hangar keepers Liability`,
    icon: 'product_thin',
    color: 'red',
    code: 'APH',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.AirportLiability]: {
    id: 'airport-liability',
    title: $localize`:@@cob-ARE:Airport Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: 'ARE',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.AssetAllRisk]: {
    id: 'asset-all-risk',
    title: $localize`:@@cob-334:Asset All Risk`,
    icon: 'product_thin',
    color: 'blue',
    code: '334',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.EnergyProperty]: {
    id: 'energy-property',
    title: $localize`:@@cob-ENPR:Energy Property`,
    icon: 'product_thin',
    color: 'pink',
    code: 'ENPR',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.EnergyLiability]: {
    id: 'energy-liability',
    title: $localize`:@@cob-TPL:Energy Liability`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'TPL',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MedicalMalpractice]: {
    id: 'medical-malpractice',
    title: $localize`:@@cob-169:Medical Malpractice`,
    icon: 'product_thin',
    color: 'blue',
    code: '169',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ProfIndtySolicitors]: {
    id: 'prof-indty-solicitors',
    title: $localize`:@@cob-125:Prof Indty Solicitors`,
    icon: 'product_thin',
    color: 'blue',
    code: '125',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.BankersBlanketBond]: {
    id: 'bankers-blanket-bond',
    title: $localize`:@@cob-BBB:Bankers Blanket Bond`,
    icon: 'product_thin',
    color: 'blue',
    code: 'BBB',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Fire]: {
    id: 'fire',
    title: $localize`:@@cob-569:FIRE`,
    icon: 'product_thin',
    color: 'blue',
    code: '569',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Motorcycle]: {
    id: 'motorcycle',
    title: $localize`:@@cob-252:Motorcycle`,
    icon: 'product_thin',
    color: 'yellow',
    code: '252',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MaterialDamageAndBusinessInt]: {
    id: 'material-damage-and-business-int',
    title: $localize`:@@cob-333:Material Damage and Business Int`,
    icon: 'product_thin',
    color: 'orange',
    code: '333',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.AircraftHullLiability]: {
    id: 'aircraft-hull-liability',
    title: $localize`:@@cob-AHL:Aircraft Hull & Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'AHL',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ContractorsPlantAndEquipment]: {
    id: 'contractors-plant-and-equipment',
    title: $localize`:@@cob-393:Contractors Plant and Equipment`,
    icon: 'product_thin',
    color: 'blue',
    code: '393',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ExcessLiability]: {
    id: 'excess-liability',
    title: $localize`:@@cob-ELI:Excess Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'ELI',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MotorCommercialVehicle]: {
    id: 'motor-commercial-vehicle',
    title: $localize`:@@cob-202:Motor Commercial Vehicle`,
    icon: 'product_thin',
    color: 'green',
    code: '202',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.MotorSpecialTypes]: {
    id: 'motor-special-types',
    title: $localize`:@@cob-210:Motor Special Types`,
    icon: 'product_thin',
    color: 'yellow',
    code: '210',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.PropertyOwnersCombined]: {
    id: 'property-owners-combined',
    title: $localize`:@@cob-306:Property Owners Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '306',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.EngineeringMachineryBreakdown]: {
    id: 'engineering-machinery-breakdown',
    title: $localize`:@@cob-328:Engineering Machinery Breakdown`,
    icon: 'product_thin',
    color: 'orange',
    code: '328',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.Engineering]: {
    id: 'engineering',
    title: $localize`:@@cob-305:Engineering`,
    icon: 'product_thin',
    color: 'yellow',
    code: '305',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ArmoredCarTransitRisks]: {
    id: 'armored-car-transit-risks',
    title: $localize`:@@cob-ACR:Armored Car Transit Risks`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'ACR',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ContractFrustrationNonPayment]: {
    id: 'contract-frustration-non-payment',
    title: $localize`:@@cob-CFP:Contract Frustration Non Payment`,
    icon: 'product_thin',
    color: 'red',
    code: 'CFP',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ContractorsAllRisks]: {
    id: 'contractors-all-risks',
    title: $localize`:@@cob-316:Contractors All Risks`,
    icon: 'product_thin',
    color: 'green',
    code: '316',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.ErectionAllRisks]: {
    id: 'erection-all-risks',
    title: $localize`:@@cob-12:Erection All Risks`,
    icon: 'product_thin',
    color: 'orange',
    code: '12',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
  [BrazilPncClassOfBusinessId.LossOfProfits]: {
    id: 'loss-of-profits',
    title: $localize`:@@cob-LOP:Loss of Profits`,
    icon: 'product_thin',
    color: 'green',
    code: 'LOP',
    type: 'policy',
    misc: {
      department: 'Brazil P&C',
      country: 'Brazil',
      countryCode: 'BRA',
    },
  },
};

export const CHILE_PEOPLE_SOLUTIONS_COB_META_DATA: Record<
  ChilePeopleSolutionsClassOfBusinessId,
  CobMeta
> = {
  [ChilePeopleSolutionsClassOfBusinessId.PersonalAccident]: {
    id: 'personal-accident',
    title: $localize`:@@cob-454:Personal Accident`,
    icon: 'product_thin',
    color: 'green',
    code: '454',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.TravelBusinessBenefits]: {
    id: 'travel-business-benefits',
    title: $localize`:@@cob-728:Travel Business (Benefits)`,
    icon: 'product_thin',
    color: 'pink',
    code: '728',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.PrivateMedicalInsurance]: {
    id: 'private-medical-insurance',
    title: $localize`:@@cob-625:Private Medical Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '625',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.GroupLifeAssurance]: {
    id: 'group-life-assurance',
    title: $localize`:@@cob-640:Group Life Assurance`,
    icon: 'product_thin',
    color: 'red',
    code: '640',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.GroupPersonalAccident]: {
    id: 'group-personal-accident',
    title: $localize`:@@cob-452:Group Personal Accident`,
    icon: 'product_thin',
    color: 'red',
    code: '452',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.TravelLeisureBenefits]: {
    id: 'travel-leisure-benefits',
    title: $localize`:@@cob-727:Travel Leisure (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '727',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.NonAdvicePensionsConsultancy]: {
    id: 'non-advice-pensions-consultancy',
    title: $localize`:@@cob-598:Non-Advice Pensions Consultancy`,
    icon: 'product_thin',
    color: 'red',
    code: '598',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.GroupIncomeProtection]: {
    id: 'group-income-protection',
    title: $localize`:@@cob-262:Group Income Protection`,
    icon: 'product_thin',
    color: 'yellow',
    code: '262',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.Dental]: {
    id: 'dental',
    title: $localize`:@@cob-602:Dental`,
    icon: 'product_thin',
    color: 'blue',
    code: '602',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.Pharmacists]: {
    id: 'pharmacists',
    title: $localize`:@@cob-441:Pharmacists`,
    icon: 'product_thin',
    color: 'green',
    code: '441',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.GroupCriticalIllness]: {
    id: 'group-critical-illness',
    title: $localize`:@@cob-699:Group Critical Illness`,
    icon: 'product_thin',
    color: 'orange',
    code: '699',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.CommunicationsBenefits]: {
    id: 'communications-benefits',
    title: $localize`:@@cob-446:Communications (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '446',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePeopleSolutionsClassOfBusinessId.PersonalAccidentTravel]: {
    id: 'personal-accident-travel',
    title: $localize`:@@cob-456:Personal Accident & Travel`,
    icon: 'product_thin',
    color: 'green',
    code: '456',
    type: 'policy',
    misc: {
      department: 'Chile People Solutions',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
};

export const CHILE_PNC_COB_META_DATA: Record<
  ChilePncClassOfBusinessId,
  CobMeta
> = {
  [ChilePncClassOfBusinessId.MotorPrivateCar]: {
    id: 'motor-private-car',
    title: $localize`:@@cob-251:Motor Private Car`,
    icon: 'product_thin',
    color: 'red',
    code: '251',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.BankersBlanketBond]: {
    id: 'bankers-blanket-bond',
    title: $localize`:@@cob-BBB:Bankers Blanket Bond`,
    icon: 'product_thin',
    color: 'blue',
    code: 'BBB',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.AircraftHull]: {
    id: 'aircraft-hull',
    title: $localize`:@@cob-501:Aircraft Hull`,
    icon: 'product_thin',
    color: 'yellow',
    code: '501',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.AircraftHullLiability]: {
    id: 'aircraft-hull-liability',
    title: $localize`:@@cob-AHL:Aircraft Hull & Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'AHL',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MarineHull]: {
    id: 'marine-hull',
    title: $localize`:@@cob-530:Marine Hull`,
    icon: 'product_thin',
    color: 'pink',
    code: '530',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MarinePortPackage]: {
    id: 'marine-port-package',
    title: $localize`:@@cob-486:Marine Port Package`,
    icon: 'product_thin',
    color: 'pink',
    code: '486',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.TradeCreditInsurance]: {
    id: 'trade-credit-insurance',
    title: $localize`:@@cob-403:Trade Credit Insurance`,
    icon: 'product_thin',
    color: 'green',
    code: '403',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.CyberLiability]: {
    id: 'cyber-liability',
    title: $localize`:@@cob-183:Cyber Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '183',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.DirectorsOfficersLiability]: {
    id: 'directors-officers-liability',
    title: $localize`:@@cob-117:Directors & Officers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '117',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ProfessionalIndemnityEO]: {
    id: 'professional-indemnity-e-o',
    title: $localize`:@@cob-175:Professional Indemnity E&O`,
    icon: 'product_thin',
    color: 'blue',
    code: '175',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ContractorsPlantAndEquipment]: {
    id: 'contractors-plant-and-equipment',
    title: $localize`:@@cob-393:Contractors Plant and Equipment`,
    icon: 'product_thin',
    color: 'blue',
    code: '393',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Computers]: {
    id: 'computers',
    title: $localize`:@@cob-303:Computers`,
    icon: 'product_thin',
    color: 'blue',
    code: '303',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.EquipmentPhysicalDamage]: {
    id: 'equipment-physical-damage',
    title: $localize`:@@cob-219:Equipment Physical Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '219',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.FidelityGuaranteeEmployee]: {
    id: 'fidelity-guarantee-employee',
    title: $localize`:@@cob-402:Fidelity Guarantee Employee`,
    icon: 'product_thin',
    color: 'orange',
    code: '402',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Bonds]: {
    id: 'bonds',
    title: $localize`:@@cob-404:Bonds`,
    icon: 'product_thin',
    color: 'red',
    code: '404',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Cargo]: {
    id: 'cargo',
    title: $localize`:@@cob-529:Cargo`,
    icon: 'product_thin',
    color: 'blue',
    code: '529',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Fire]: {
    id: 'fire',
    title: $localize`:@@cob-569:FIRE`,
    icon: 'product_thin',
    color: 'blue',
    code: '569',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.AgriculturalProperty]: {
    id: 'agricultural-property',
    title: $localize`:@@cob-344:Agricultural Property`,
    icon: 'product_thin',
    color: 'red',
    code: '344',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.HomeAndMotorPortfolio]: {
    id: 'home-and-motor-portfolio',
    title: $localize`:@@cob-289:Home and Motor Portfolio`,
    icon: 'product_thin',
    color: 'pink',
    code: '289',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.AssetAllRisk]: {
    id: 'asset-all-risk',
    title: $localize`:@@cob-334:Asset All Risk`,
    icon: 'product_thin',
    color: 'blue',
    code: '334',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Motorcycle]: {
    id: 'motorcycle',
    title: $localize`:@@cob-252:Motorcycle`,
    icon: 'product_thin',
    color: 'yellow',
    code: '252',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.FineArtsInsurance]: {
    id: 'fine-arts-insurance',
    title: $localize`:@@cob-911:Fine Arts Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '911',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.PropertyDamage]: {
    id: 'property-damage',
    title: $localize`:@@cob-5:Property Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '5',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.PublicProductsLiability]: {
    id: 'public-products-liability',
    title: $localize`:@@cob-112:Public & Products Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '112',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.EnvironmentalImpairmentLiab]: {
    id: 'environmental-impairment-liab',
    title: $localize`:@@cob-152:Environmental Impairment Liab`,
    icon: 'product_thin',
    color: 'red',
    code: '152',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ExcessLiability]: {
    id: 'excess-liability',
    title: $localize`:@@cob-ELI:Excess Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'ELI',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ProductsLiability]: {
    id: 'products-liability',
    title: $localize`:@@cob-121:Products Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '121',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MarineLiability]: {
    id: 'marine-liability',
    title: $localize`:@@cob-527:Marine Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '527',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ProfIndtyInsuranceBrokers]: {
    id: 'prof-indty-insurance-brokers',
    title: $localize`:@@cob-164:Prof Indty Insurance Brokers`,
    icon: 'product_thin',
    color: 'yellow',
    code: '164',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Crime]: {
    id: 'crime',
    title: $localize`:@@cob-410:Crime`,
    icon: 'product_thin',
    color: 'red',
    code: '410',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Terrorism]: {
    id: 'terrorism',
    title: $localize`:@@cob-307:Terrorism`,
    icon: 'product_thin',
    color: 'yellow',
    code: '307',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ConstructionCombined]: {
    id: 'construction-combined',
    title: $localize`:@@cob-577:Construction Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '577',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MaterialDamageAndBusinessInt]: {
    id: 'material-damage-and-business-int',
    title: $localize`:@@cob-333:Material Damage and Business Int`,
    icon: 'product_thin',
    color: 'orange',
    code: '333',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MotorCommercialVehicle]: {
    id: 'motor-commercial-vehicle',
    title: $localize`:@@cob-202:Motor Commercial Vehicle`,
    icon: 'product_thin',
    color: 'green',
    code: '202',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MotorSpecialTypes]: {
    id: 'motor-special-types',
    title: $localize`:@@cob-210:Motor Special Types`,
    icon: 'product_thin',
    color: 'yellow',
    code: '210',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.AviationLiability]: {
    id: 'aviation-liability',
    title: $localize`:@@cob-503:Aviation Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '503',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.CommercialCombined]: {
    id: 'commercial-combined',
    title: $localize`:@@cob-301:Commercial Combined`,
    icon: 'product_thin',
    color: 'pink',
    code: '301',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MedicalMalpractice]: {
    id: 'medical-malpractice',
    title: $localize`:@@cob-169:Medical Malpractice`,
    icon: 'product_thin',
    color: 'blue',
    code: '169',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.PropertyOwnersLiability]: {
    id: 'property-owners-liability',
    title: $localize`:@@cob-155:Property Owners Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: '155',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.EventInsurance]: {
    id: 'event-insurance',
    title: $localize`:@@cob-415:Event Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '415',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.CombinedLiability]: {
    id: 'combined-liability',
    title: $localize`:@@cob-116:Combined Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '116',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.WarehouseKeepersLiability]: {
    id: 'warehouse-keepers-liability',
    title: $localize`:@@cob-389:Warehouse Keepers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '389',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MarinaOperatorsLiability]: {
    id: 'marina-operators-liability',
    title: $localize`:@@cob-520:Marina Operators Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '520',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.EmployersLiability]: {
    id: 'employers-liability',
    title: $localize`:@@cob-111:Employers Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '111',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MarineHullLiability]: {
    id: 'marine-hull-liability',
    title: $localize`:@@cob-523:Marine Hull & Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '523',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ProfIndtyFinancialServices]: {
    id: 'prof-indty-financial-services',
    title: $localize`:@@cob-184:Prof Indty Financial Services`,
    icon: 'product_thin',
    color: 'orange',
    code: '184',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ClinicalTrials]: {
    id: 'clinical-trials',
    title: $localize`:@@cob-139:Clinical Trials`,
    icon: 'product_thin',
    color: 'orange',
    code: '139',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ProfIndtyEngineers]: {
    id: 'prof-indty-engineers',
    title: $localize`:@@cob-167:Prof Indty Engineers`,
    icon: 'product_thin',
    color: 'green',
    code: '167',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MotorLiability]: {
    id: 'motor-liability',
    title: $localize`:@@cob-11:Motor Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '11',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.MotorFleet]: {
    id: 'motor-fleet',
    title: $localize`:@@cob-203:Motor Fleet`,
    icon: 'product_thin',
    color: 'pink',
    code: '203',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.FreightForwardersLiability]: {
    id: 'freight-forwarders-liability',
    title: $localize`:@@cob-552:Freight Forwarders Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '552',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ContractualFinancialLoss]: {
    id: 'contractual-financial-loss',
    title: $localize`:@@cob-432:Contractual Financial Loss`,
    icon: 'product_thin',
    color: 'orange',
    code: '432',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.LossOfAnticipatedRentalIncome]: {
    id: 'loss-of-anticipated-rental-income',
    title: $localize`:@@cob-360:Loss of Anticipated Rental Income`,
    icon: 'product_thin',
    color: 'yellow',
    code: '360',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Livestock]: {
    id: 'livestock',
    title: $localize`:@@cob-374:Livestock`,
    icon: 'product_thin',
    color: 'red',
    code: '374',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.AircraftHullWar]: {
    id: 'aircraft-hull-war',
    title: $localize`:@@cob-HUW:Aircraft Hull War`,
    icon: 'product_thin',
    color: 'green',
    code: 'HUW',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.AviationHangarKeepersLiability]: {
    id: 'aviation-hangar-keepers-liability',
    title: $localize`:@@cob-APH:Aviation Hangar keepers Liability`,
    icon: 'product_thin',
    color: 'red',
    code: 'APH',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.AirportLiability]: {
    id: 'airport-liability',
    title: $localize`:@@cob-ARE:Airport Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: 'ARE',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.EnergyProperty]: {
    id: 'energy-property',
    title: $localize`:@@cob-ENPR:Energy Property`,
    icon: 'product_thin',
    color: 'pink',
    code: 'ENPR',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.EnergyLiability]: {
    id: 'energy-liability',
    title: $localize`:@@cob-TPL:Energy Liability`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'TPL',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ProfIndtySolicitors]: {
    id: 'prof-indty-solicitors',
    title: $localize`:@@cob-125:Prof Indty Solicitors`,
    icon: 'product_thin',
    color: 'blue',
    code: '125',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.PropertyOwnersCombined]: {
    id: 'property-owners-combined',
    title: $localize`:@@cob-306:Property Owners Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '306',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.EngineeringMachineryBreakdown]: {
    id: 'engineering-machinery-breakdown',
    title: $localize`:@@cob-328:Engineering Machinery Breakdown`,
    icon: 'product_thin',
    color: 'orange',
    code: '328',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.Engineering]: {
    id: 'engineering',
    title: $localize`:@@cob-305:Engineering`,
    icon: 'product_thin',
    color: 'yellow',
    code: '305',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ArmoredCarTransitRisks]: {
    id: 'armored-car-transit-risks',
    title: $localize`:@@cob-ACR:Armored Car Transit Risks`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'ACR',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ContractFrustrationNonPayment]: {
    id: 'contract-frustration-non-payment',
    title: $localize`:@@cob-CFP:Contract Frustration Non Payment`,
    icon: 'product_thin',
    color: 'red',
    code: 'CFP',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ContractorsAllRisks]: {
    id: 'contractors-all-risks',
    title: $localize`:@@cob-316:Contractors All Risks`,
    icon: 'product_thin',
    color: 'green',
    code: '316',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
  [ChilePncClassOfBusinessId.ErectionAllRisks]: {
    id: 'erection-all-risks',
    title: $localize`:@@cob-12:Erection All Risks`,
    icon: 'product_thin',
    color: 'orange',
    code: '12',
    type: 'policy',
    misc: {
      department: 'Chile P&C',
      country: 'Chile',
      countryCode: 'CHL',
    },
  },
};

export const COLOMBIA_PEOPLE_SOLUTIONS_COB_META_DATA: Record<
  ColombiaPeopleSolutionsClassOfBusinessId,
  CobMeta
> = {
  [ColombiaPeopleSolutionsClassOfBusinessId.PersonalAccident]: {
    id: 'personal-accident',
    title: $localize`:@@cob-454:Personal Accident`,
    icon: 'product_thin',
    color: 'green',
    code: '454',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.PersonalAccidentTravel]: {
    id: 'personal-accident-travel',
    title: $localize`:@@cob-456:Personal Accident & Travel`,
    icon: 'product_thin',
    color: 'green',
    code: '456',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.TravelLeisureBenefits]: {
    id: 'travel-leisure-benefits',
    title: $localize`:@@cob-727:Travel Leisure (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '727',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.PrivateMedicalInsurance]: {
    id: 'private-medical-insurance',
    title: $localize`:@@cob-625:Private Medical Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '625',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.GroupCriticalIllness]: {
    id: 'group-critical-illness',
    title: $localize`:@@cob-699:Group Critical Illness`,
    icon: 'product_thin',
    color: 'orange',
    code: '699',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.GroupLifeAssurance]: {
    id: 'group-life-assurance',
    title: $localize`:@@cob-640:Group Life Assurance`,
    icon: 'product_thin',
    color: 'red',
    code: '640',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.Dental]: {
    id: 'dental',
    title: $localize`:@@cob-602:Dental`,
    icon: 'product_thin',
    color: 'blue',
    code: '602',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.Funeral]: {
    id: 'funeral',
    title: $localize`:@@cob-595:Funeral`,
    icon: 'product_thin',
    color: 'pink',
    code: '595',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.GroupIncomeProtection]: {
    id: 'group-income-protection',
    title: $localize`:@@cob-262:Group Income Protection`,
    icon: 'product_thin',
    color: 'yellow',
    code: '262',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.GroupPersonalAccident]: {
    id: 'group-personal-accident',
    title: $localize`:@@cob-452:Group Personal Accident`,
    icon: 'product_thin',
    color: 'red',
    code: '452',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.NonAdvicePensionsConsultancy]: {
    id: 'non-advice-pensions-consultancy',
    title: $localize`:@@cob-598:Non-Advice Pensions Consultancy`,
    icon: 'product_thin',
    color: 'red',
    code: '598',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.TravelBusinessBenefits]: {
    id: 'travel-business-benefits',
    title: $localize`:@@cob-728:Travel Business (Benefits)`,
    icon: 'product_thin',
    color: 'pink',
    code: '728',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.Pharmacists]: {
    id: 'pharmacists',
    title: $localize`:@@cob-441:Pharmacists`,
    icon: 'product_thin',
    color: 'green',
    code: '441',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.CommunicationsBenefits]: {
    id: 'communications-benefits',
    title: $localize`:@@cob-446:Communications (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '446',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPeopleSolutionsClassOfBusinessId.WorkersCompensation]: {
    id: 'workers-compensation',
    title: $localize`:@@cob-WCA:Workers Compensation`,
    icon: 'product_thin',
    color: 'green',
    code: 'WCA',
    type: 'policy',
    misc: {
      department: 'Colombia People Solutions',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
};

export const COLOMBIA_PNC_COB_META_DATA: Record<
  ColombiaPncClassOfBusinessId,
  CobMeta
> = {
  [ColombiaPncClassOfBusinessId.AgriculturalProperty]: {
    id: 'agricultural-property',
    title: $localize`:@@cob-344:Agricultural Property`,
    icon: 'product_thin',
    color: 'red',
    code: '344',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ContractualFinancialLoss]: {
    id: 'contractual-financial-loss',
    title: $localize`:@@cob-432:Contractual Financial Loss`,
    icon: 'product_thin',
    color: 'orange',
    code: '432',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MotorPrivateCar]: {
    id: 'motor-private-car',
    title: $localize`:@@cob-251:Motor Private Car`,
    icon: 'product_thin',
    color: 'red',
    code: '251',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MotorFleet]: {
    id: 'motor-fleet',
    title: $localize`:@@cob-203:Motor Fleet`,
    icon: 'product_thin',
    color: 'pink',
    code: '203',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Motorcycle]: {
    id: 'motorcycle',
    title: $localize`:@@cob-252:Motorcycle`,
    icon: 'product_thin',
    color: 'yellow',
    code: '252',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MotorSpecialTypes]: {
    id: 'motor-special-types',
    title: $localize`:@@cob-210:Motor Special Types`,
    icon: 'product_thin',
    color: 'yellow',
    code: '210',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.AircraftHull]: {
    id: 'aircraft-hull',
    title: $localize`:@@cob-510:Aircraft Hull`,
    icon: 'product_thin',
    color: 'yellow',
    code: '501',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.BankersBlanketBond]: {
    id: 'bankers-blanket-bond',
    title: $localize`:@@cob-BBB:Bankers Blanket Bond`,
    icon: 'product_thin',
    color: 'blue',
    code: 'BBB',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.AssetAllRisk]: {
    id: 'asset-all-risk',
    title: $localize`:@@cob-334:Asset All Risk`,
    icon: 'product_thin',
    color: 'blue',
    code: '334',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MarineHull]: {
    id: 'marine-hull',
    title: $localize`:@@cob-530:Marine Hull`,
    icon: 'product_thin',
    color: 'pink',
    code: '530',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.PropertyOwnersCombined]: {
    id: 'property-owners-combined',
    title: $localize`:@@cob-306:Property Owners Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '306',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Bonds]: {
    id: 'bonds',
    title: $localize`:@@cob-404:Bonds`,
    icon: 'product_thin',
    color: 'red',
    code: '404',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.CyberLiability]: {
    id: 'cyber-liability',
    title: $localize`:@@cob-183:Cyber Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '183',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.DirectorsOfficersLiability]: {
    id: 'directors-officers-liability',
    title: $localize`:@@cob-117:Directors & Officers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '117',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Computers]: {
    id: 'computers',
    title: $localize`:@@cob-303:Computers`,
    icon: 'product_thin',
    color: 'blue',
    code: '303',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.FidelityGuaranteeEmployee]: {
    id: 'fidelity-guarantee-employee',
    title: $localize`:@@cob-402:Fidelity Guarantee Employee`,
    icon: 'product_thin',
    color: 'orange',
    code: '402',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Fire]: {
    id: 'fire',
    title: $localize`:@@cob-569:FIRE`,
    icon: 'product_thin',
    color: 'blue',
    code: '569',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.HomeAndMotorPortfolio]: {
    id: 'home-and-motor-portfolio',
    title: $localize`:@@cob-289:Home and Motor Portfolio`,
    icon: 'product_thin',
    color: 'pink',
    code: '289',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.LossOfProfits]: {
    id: 'loss-of-profits',
    title: $localize`:@@cob-LOP:Loss of Profits`,
    icon: 'product_thin',
    color: 'green',
    code: 'LOP',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Livestock]: {
    id: 'livestock',
    title: $localize`:@@cob-374:Livestock`,
    icon: 'product_thin',
    color: 'red',
    code: '374',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.CommercialCombined]: {
    id: 'commercial-combined',
    title: $localize`:@@cob-301:Commercial Combined`,
    icon: 'product_thin',
    color: 'pink',
    code: '301',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.EnvironmentalImpairmentLiab]: {
    id: 'environmental-impairment-liab',
    title: $localize`:@@cob-152:Environmental Impairment Liab`,
    icon: 'product_thin',
    color: 'red',
    code: '152',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.PublicProductsLiability]: {
    id: 'public-products-liability',
    title: $localize`:@@cob-112:Public & Products Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '112',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MedicalMalpractice]: {
    id: 'medical-malpractice',
    title: $localize`:@@cob-169:Medical Malpractice`,
    icon: 'product_thin',
    color: 'blue',
    code: '169',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ProfessionalIndemnityEO]: {
    id: 'professional-indemnity-e-o',
    title: $localize`:@@cob-175:Professional Indemnity E&O`,
    icon: 'product_thin',
    color: 'blue',
    code: '175',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.EngineeringMachineryBreakdown]: {
    id: 'engineering-machinery-breakdown',
    title: $localize`:@@cob-328:Engineering Machinery Breakdown`,
    icon: 'product_thin',
    color: 'orange',
    code: '328',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.TradeCreditInsurance]: {
    id: 'trade-credit-insurance',
    title: $localize`:@@cob-403:Trade Credit Insurance`,
    icon: 'product_thin',
    color: 'green',
    code: '403',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MotorLiability]: {
    id: 'motor-liability',
    title: $localize`:@@cob-11:Motor Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '11',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Crime]: {
    id: 'crime',
    title: $localize`:@@cob-410:Crime`,
    icon: 'product_thin',
    color: 'red',
    code: '410',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ConstructionCombined]: {
    id: 'construction-combined',
    title: $localize`:@@cob-577:Construction Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '577',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.PropertyDamage]: {
    id: 'property-damage',
    title: $localize`:@@cob-5:Property Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '5',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Engineering]: {
    id: 'engineering',
    title: $localize`:@@cob-305:Engineering`,
    icon: 'product_thin',
    color: 'yellow',
    code: '305',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ArmoredCarTransitRisks]: {
    id: 'armored-car-transit-risks',
    title: $localize`:@@cob-ACR:Armored Car Transit Risks`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'ACR',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Cargo]: {
    id: 'cargo',
    title: $localize`:@@cob-529:Cargo`,
    icon: 'product_thin',
    color: 'blue',
    code: '529',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.AviationLiability]: {
    id: 'aviation-liability',
    title: $localize`:@@cob-503:Aviation Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '503',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.PropertyOwnersLiability]: {
    id: 'property-owners-liability',
    title: $localize`:@@cob-155:Property Owners Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: '155',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MaterialDamageAndBusinessInt]: {
    id: 'material-damage-and-business-int',
    title: $localize`:@@cob-333:Material Damage and Business Int`,
    icon: 'product_thin',
    color: 'orange',
    code: '333',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.EquipmentPhysicalDamage]: {
    id: 'equipment-physical-damage',
    title: $localize`:@@cob-219:Equipment Physical Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '219',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.FineArtsInsurance]: {
    id: 'fine-arts-insurance',
    title: $localize`:@@cob-911:Fine Arts Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '911',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.EventInsurance]: {
    id: 'event-insurance',
    title: $localize`:@@cob-415:Event Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '415',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Terrorism]: {
    id: 'terrorism',
    title: $localize`:@@cob-307:Terrorism`,
    icon: 'product_thin',
    color: 'yellow',
    code: '307',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.CombinedLiability]: {
    id: 'combined-liability',
    title: $localize`:@@cob-116:Combined Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '116',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.WarehouseKeepersLiability]: {
    id: 'warehouse-keepers-liability',
    title: $localize`:@@cob-389:Warehouse Keepers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '389',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MarinaOperatorsLiability]: {
    id: 'marina-operators-liability',
    title: $localize`:@@cob-520:Marina Operators Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '520',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.EmployersLiability]: {
    id: 'employers-liability',
    title: $localize`:@@cob-111:Employers Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '111',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MarineHullLiability]: {
    id: 'marine-hull-liability',
    title: $localize`:@@cob-523:Marine Hull & Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '523',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ProductsLiability]: {
    id: 'products-liability',
    title: $localize`:@@cob-121:Products Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '121',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ProfIndtyInsuranceBrokers]: {
    id: 'prof-indty-insurance-brokers',
    title: $localize`:@@cob-164:Prof Indty Insurance Brokers`,
    icon: 'product_thin',
    color: 'yellow',
    code: '164',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ProfIndtyFinancialServices]: {
    id: 'prof-indty-financial-services',
    title: $localize`:@@cob-184:Prof Indty Financial Services`,
    icon: 'product_thin',
    color: 'orange',
    code: '184',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ClinicalTrials]: {
    id: 'clinical-trials',
    title: $localize`:@@cob-139:Clinical Trials`,
    icon: 'product_thin',
    color: 'orange',
    code: '139',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ProfIndtyEngineers]: {
    id: 'prof-indty-engineers',
    title: $localize`:@@cob-167:Prof Indty Engineers`,
    icon: 'product_thin',
    color: 'green',
    code: '167',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MarineLiability]: {
    id: 'marine-liability',
    title: $localize`:@@cob-527:Marine Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '527',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.FreightForwardersLiability]: {
    id: 'freight-forwarders-liability',
    title: $localize`:@@cob-552:Freight Forwarders Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '552',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.LossOfAnticipatedRentalIncome]: {
    id: 'loss-of-anticipated-rental-income',
    title: $localize`:@@cob-360:Loss of Anticipated Rental Income`,
    icon: 'product_thin',
    color: 'yellow',
    code: '360',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MarinePortPackage]: {
    id: 'marine-port-package',
    title: $localize`:@@cob-486:Marine Port Package`,
    icon: 'product_thin',
    color: 'pink',
    code: '486',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.AircraftHullWar]: {
    id: 'aircraft-hull-war',
    title: $localize`:@@cob-HUW:Aircraft Hull War`,
    icon: 'product_thin',
    color: 'green',
    code: 'HUW',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.AviationHangarKeepersLiability]: {
    id: 'aviation-hangar-keepers-liability',
    title: $localize`:@@cob-APH:Aviation Hangar keepers Liability`,
    icon: 'product_thin',
    color: 'red',
    code: 'APH',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.AirportLiability]: {
    id: 'airport-liability',
    title: $localize`:@@cob-ARE:Airport Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: 'ARE',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.EnergyProperty]: {
    id: 'energy-property',
    title: $localize`:@@cob-ENPR:Energy Property`,
    icon: 'product_thin',
    color: 'pink',
    code: 'ENPR',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.EnergyLiability]: {
    id: 'energy-liability',
    title: $localize`:@@cob-TPL:Energy Liability`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'TPL',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ProfIndtySolicitors]: {
    id: 'prof-indty-solicitors',
    title: $localize`:@@cob-125:Prof Indty Solicitors`,
    icon: 'product_thin',
    color: 'blue',
    code: '125',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.AircraftHullLiability]: {
    id: 'aircraft-hull-liability',
    title: $localize`:@@cob-AHL:Aircraft Hull & Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'AHL',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ContractorsPlantAndEquipment]: {
    id: 'contractors-plant-and-equipment',
    title: $localize`:@@cob-393:Contractors Plant and Equipment`,
    icon: 'product_thin',
    color: 'blue',
    code: '393',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ExcessLiability]: {
    id: 'excess-liability',
    title: $localize`:@@cob-ELI:Excess Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'ELI',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.MotorCommercialVehicle]: {
    id: 'motor-commercial-vehicle',
    title: $localize`:@@cob-202:Motor Commercial Vehicle`,
    icon: 'product_thin',
    color: 'green',
    code: '202',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ContractFrustrationNonPayment]: {
    id: 'contract-frustration-non-payment',
    title: $localize`:@@cob-CFP:Contract Frustration Non Payment`,
    icon: 'product_thin',
    color: 'red',
    code: 'CFP',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ContractorsAllRisks]: {
    id: 'contractors-all-risks',
    title: $localize`:@@cob-316:Contractors All Risks`,
    icon: 'product_thin',
    color: 'green',
    code: '316',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
  [ColombiaPncClassOfBusinessId.ErectionAllRisks]: {
    id: 'erection-all-risks',
    title: $localize`:@@cob-12:Erection All Risks`,
    icon: 'product_thin',
    color: 'orange',
    code: '12',
    type: 'policy',
    misc: {
      department: 'Colombia P&C',
      country: 'Colombia',
      countryCode: 'COL',
    },
  },
};

export const MEXICO_PEOPLE_SOLUTIONS_COB_META_DATA: Record<
  MexicoPeopleSolutionsClassOfBusinessId,
  CobMeta
> = {
  [MexicoPeopleSolutionsClassOfBusinessId.PrivateMedicalInsurance]: {
    id: 'private-medical-insurance',
    title: $localize`:@@cob-625:Private Medical Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '625',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.GroupLifeAssurance]: {
    id: 'group-life-assurance',
    title: $localize`:@@cob-640:Group Life Assurance`,
    icon: 'product_thin',
    color: 'red',
    code: '640',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.GroupPersonalAccident]: {
    id: 'group-personal-accident',
    title: $localize`:@@cob-452:Group Personal Accident`,
    icon: 'product_thin',
    color: 'red',
    code: '452',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.GroupCriticalIllness]: {
    id: 'group-critical-illness',
    title: $localize`:@@cob-699:Group Critical Illness`,
    icon: 'product_thin',
    color: 'orange',
    code: '699',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.PersonalAccident]: {
    id: 'personal-accident',
    title: $localize`:@@cob-454:Personal Accident`,
    icon: 'product_thin',
    color: 'green',
    code: '454',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.TravelLeisureBenefits]: {
    id: 'travel-leisure-benefits',
    title: $localize`:@@cob-727:Travel Leisure (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '727',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.NonAdvicePensionsConsultancy]: {
    id: 'non-advice-pensions-consultancy',
    title: $localize`:@@cob-598:Non-Advice Pensions Consultancy`,
    icon: 'product_thin',
    color: 'red',
    code: '598',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.TravelBusinessBenefits]: {
    id: 'travel-business-benefits',
    title: $localize`:@@cob-728:Travel Business (Benefits)`,
    icon: 'product_thin',
    color: 'pink',
    code: '728',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.GroupIncomeProtection]: {
    id: 'group-income-protection',
    title: $localize`:@@cob-262:Group Income Protection`,
    icon: 'product_thin',
    color: 'yellow',
    code: '262',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.Dental]: {
    id: 'dental',
    title: $localize`:@@cob-602:Dental`,
    icon: 'product_thin',
    color: 'blue',
    code: '602',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.Pharmacists]: {
    id: 'pharmacists',
    title: $localize`:@@cob-441:Pharmacists`,
    icon: 'product_thin',
    color: 'green',
    code: '441',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.CommunicationsBenefits]: {
    id: 'communications-benefits',
    title: $localize`:@@cob-446:Communications (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '446',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPeopleSolutionsClassOfBusinessId.PersonalAccidentTravel]: {
    id: 'personal-accident-travel',
    title: $localize`:@@cob-456:Personal Accident & Travel`,
    icon: 'product_thin',
    color: 'green',
    code: '456',
    type: 'policy',
    misc: {
      department: 'Mexico People Solutions',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
};

export const MEXICO_PNC_COB_META_DATA: Record<
  MexicoPncClassOfBusinessId,
  CobMeta
> = {
  [MexicoPncClassOfBusinessId.HomeAndMotorPortfolio]: {
    id: 'home-and-motor-portfolio',
    title: $localize`:@@cob-289:Home and Motor Portfolio`,
    icon: 'product_thin',
    color: 'pink',
    code: '289',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MotorFleet]: {
    id: 'motor-fleet',
    title: $localize`:@@cob-203:Motor Fleet`,
    icon: 'product_thin',
    color: 'pink',
    code: '203',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MotorSpecialTypes]: {
    id: 'motor-special-types',
    title: $localize`:@@cob-210:Motor Special Types`,
    icon: 'product_thin',
    color: 'yellow',
    code: '210',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Motorcycle]: {
    id: 'motorcycle',
    title: $localize`:@@cob-252:Motorcycle`,
    icon: 'product_thin',
    color: 'yellow',
    code: '252',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.CommercialCombined]: {
    id: 'commercial-combined',
    title: $localize`:@@cob-301:Commercial Combined`,
    icon: 'product_thin',
    color: 'pink',
    code: '301',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.AssetAllRisk]: {
    id: 'asset-all-risk',
    title: $localize`:@@cob-334:Asset All Risk`,
    icon: 'product_thin',
    color: 'blue',
    code: '334',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Cargo]: {
    id: 'cargo',
    title: $localize`:@@cob-529:Cargo`,
    icon: 'product_thin',
    color: 'blue',
    code: '529',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Fire]: {
    id: 'fire',
    title: $localize`:@@cob-569:FIRE`,
    icon: 'product_thin',
    color: 'blue',
    code: '569',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MarineHull]: {
    id: 'marine-hull',
    title: $localize`:@@cob-530:Marine Hull`,
    icon: 'product_thin',
    color: 'pink',
    code: '530',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.PublicProductsLiability]: {
    id: 'public-products-liability',
    title: $localize`:@@cob-112:Public & Products Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '112',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Terrorism]: {
    id: 'terrorism',
    title: $localize`:@@cob-307:Terrorism`,
    icon: 'product_thin',
    color: 'yellow',
    code: '307',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.FidelityGuaranteeEmployee]: {
    id: 'fidelity-guarantee-employee',
    title: $localize`:@@cob-402:Fidelity Guarantee Employee`,
    icon: 'product_thin',
    color: 'orange',
    code: '402',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.TradeCreditInsurance]: {
    id: 'trade-credit-insurance',
    title: $localize`:@@cob-403:Trade Credit Insurance`,
    icon: 'product_thin',
    color: 'green',
    code: '403',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Bonds]: {
    id: 'bonds',
    title: $localize`:@@cob-404:Bonds`,
    icon: 'product_thin',
    color: 'red',
    code: '404',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.BankersBlanketBond]: {
    id: 'bankers-blanket-bond',
    title: $localize`:@@cob-BBB:Bankers Blanket Bond`,
    icon: 'product_thin',
    color: 'blue',
    code: 'BBB',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.CyberLiability]: {
    id: 'cyber-liability',
    title: $localize`:@@cob-183:Cyber Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '183',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.DirectorsOfficersLiability]: {
    id: 'directors-officers-liability',
    title: $localize`:@@cob-117:Directors & Officers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '117',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.PropertyOwnersLiability]: {
    id: 'property-owners-liability',
    title: $localize`:@@cob-155:Property Owners Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: '155',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.AviationLiability]: {
    id: 'aviation-liability',
    title: $localize`:@@cob-503:Aviation Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '503',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MotorPrivateCar]: {
    id: 'motor-private-car',
    title: $localize`:@@cob-251:Motor Private Car`,
    icon: 'product_thin',
    color: 'red',
    code: '251',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.AgriculturalProperty]: {
    id: 'agricultural-property',
    title: $localize`:@@cob-344:Agricultural Property`,
    icon: 'product_thin',
    color: 'red',
    code: '344',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MedicalMalpractice]: {
    id: 'medical-malpractice',
    title: $localize`:@@cob-169:Medical Malpractice`,
    icon: 'product_thin',
    color: 'blue',
    code: '169',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ProfessionalIndemnityEO]: {
    id: 'professional-indemnity-e-o',
    title: $localize`:@@cob-175:Professional Indemnity E&O`,
    icon: 'product_thin',
    color: 'blue',
    code: '175',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Crime]: {
    id: 'crime',
    title: $localize`:@@cob-410:Crime`,
    icon: 'product_thin',
    color: 'red',
    code: '410',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Computers]: {
    id: 'computers',
    title: $localize`:@@cob-303:Computers`,
    icon: 'product_thin',
    color: 'blue',
    code: '303',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MaterialDamageAndBusinessInt]: {
    id: 'material-damage-and-business-int',
    title: $localize`:@@cob-333:Material Damage and Business Int`,
    icon: 'product_thin',
    color: 'orange',
    code: '333',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ConstructionCombined]: {
    id: 'construction-combined',
    title: $localize`:@@cob-577:Construction Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '577',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.EquipmentPhysicalDamage]: {
    id: 'equipment-physical-damage',
    title: $localize`:@@cob-219:Equipment Physical Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '219',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.FineArtsInsurance]: {
    id: 'fine-arts-insurance',
    title: $localize`:@@cob-911:Fine Arts Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '911',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.EventInsurance]: {
    id: 'event-insurance',
    title: $localize`:@@cob-415:Event Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '415',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.PropertyDamage]: {
    id: 'property-damage',
    title: $localize`:@@cob-5:Property Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '5',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.CombinedLiability]: {
    id: 'combined-liability',
    title: $localize`:@@cob-116:Combined Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '116',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.EnvironmentalImpairmentLiab]: {
    id: 'environmental-impairment-liab',
    title: $localize`:@@cob-152:Environmental Impairment Liab`,
    icon: 'product_thin',
    color: 'red',
    code: '152',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.WarehouseKeepersLiability]: {
    id: 'warehouse-keepers-liability',
    title: $localize`:@@cob-389:Warehouse Keepers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '389',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MarinaOperatorsLiability]: {
    id: 'marina-operators-liability',
    title: $localize`:@@cob-520:Marina Operators Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '520',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.EmployersLiability]: {
    id: 'employers-liability',
    title: $localize`:@@cob-111:Employers Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '111',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MarineHullLiability]: {
    id: 'marine-hull-liability',
    title: $localize`:@@cob-523:Marine Hull & Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '523',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ProductsLiability]: {
    id: 'products-liability',
    title: $localize`:@@cob-121:Products Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '121',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ProfIndtyInsuranceBrokers]: {
    id: 'prof-indty-insurance-brokers',
    title: $localize`:@@cob-164:Prof Indty Insurance Brokers`,
    icon: 'product_thin',
    color: 'yellow',
    code: '164',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ProfIndtyFinancialServices]: {
    id: 'prof-indty-financial-services',
    title: $localize`:@@cob-184:Prof Indty Financial Services`,
    icon: 'product_thin',
    color: 'orange',
    code: '184',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ClinicalTrials]: {
    id: 'clinical-trials',
    title: $localize`:@@cob-139:Clinical Trials`,
    icon: 'product_thin',
    color: 'orange',
    code: '139',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ProfIndtyEngineers]: {
    id: 'prof-indty-engineers',
    title: $localize`:@@cob-167:Prof Indty Engineers`,
    icon: 'product_thin',
    color: 'green',
    code: '167',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MotorLiability]: {
    id: 'motor-liability',
    title: $localize`:@@cob-11:Motor Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '11',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MarineLiability]: {
    id: 'marine-liability',
    title: $localize`:@@cob-527:Marine Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '527',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.FreightForwardersLiability]: {
    id: 'freight-forwarders-liability',
    title: $localize`:@@cob-552:Freight Forwarders Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '552',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ContractualFinancialLoss]: {
    id: 'contractual-financial-loss',
    title: $localize`:@@cob-432:Contractual Financial Loss`,
    icon: 'product_thin',
    color: 'orange',
    code: '432',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.LossOfAnticipatedRentalIncome]: {
    id: 'loss-of-anticipated-rental-income',
    title: $localize`:@@cob-360:Loss of Anticipated Rental Income`,
    icon: 'product_thin',
    color: 'yellow',
    code: '360',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Livestock]: {
    id: 'livestock',
    title: $localize`:@@cob-374:Livestock`,
    icon: 'product_thin',
    color: 'red',
    code: '374',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MarinePortPackage]: {
    id: 'marine-port-package',
    title: $localize`:@@cob-486:Marine Port Package`,
    icon: 'product_thin',
    color: 'pink',
    code: '486',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.AircraftHull]: {
    id: 'aircraft-hull',
    title: $localize`:@@cob-501:Aircraft Hull`,
    icon: 'product_thin',
    color: 'yellow',
    code: '501',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.AircraftHullWar]: {
    id: 'aircraft-hull-war',
    title: $localize`:@@cob-HUW:Aircraft Hull War`,
    icon: 'product_thin',
    color: 'green',
    code: 'HUW',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.AviationHangarKeepersLiability]: {
    id: 'aviation-hangar-keepers-liability',
    title: $localize`:@@cob-APH:Aviation Hangar keepers Liability`,
    icon: 'product_thin',
    color: 'red',
    code: 'APH',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.AirportLiability]: {
    id: 'airport-liability',
    title: $localize`:@@cob-ARE:Airport Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: 'ARE',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.EnergyProperty]: {
    id: 'energy-property',
    title: $localize`:@@cob-ENPR:Energy Property`,
    icon: 'product_thin',
    color: 'pink',
    code: 'ENPR',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.EnergyLiability]: {
    id: 'energy-liability',
    title: $localize`:@@cob-ELI:Energy Liability`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'TPL',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ProfIndtySolicitors]: {
    id: 'prof-indty-solicitors',
    title: $localize`:@@cob-125:Prof Indty Solicitors`,
    icon: 'product_thin',
    color: 'blue',
    code: '125',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.AircraftHullLiability]: {
    id: 'aircraft-hull-liability',
    title: $localize`:@@cob-AHL:Aircraft Hull & Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'AHL',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ContractorsPlantAndEquipment]: {
    id: 'contractors-plant-and-equipment',
    title: $localize`:@@cob-393:Contractors Plant and Equipment`,
    icon: 'product_thin',
    color: 'blue',
    code: '393',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ExcessLiability]: {
    id: 'excess-liability',
    title: $localize`:@@cob-ELI:Excess Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'ELI',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.MotorCommercialVehicle]: {
    id: 'motor-commercial-vehicle',
    title: $localize`:@@cob-202:Motor Commercial Vehicle`,
    icon: 'product_thin',
    color: 'green',
    code: '202',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.PropertyOwnersCombined]: {
    id: 'property-owners-combined',
    title: $localize`:@@cob-306:Property Owners Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '306',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.EngineeringMachineryBreakdown]: {
    id: 'engineering-machinery-breakdown',
    title: $localize`:@@cob-328:Engineering Machinery Breakdown`,
    icon: 'product_thin',
    color: 'orange',
    code: '328',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.Engineering]: {
    id: 'engineering',
    title: $localize`:@@cob-305:Engineering`,
    icon: 'product_thin',
    color: 'yellow',
    code: '305',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ArmoredCarTransitRisks]: {
    id: 'armored-car-transit-risks',
    title: $localize`:@@cob-ACR:Armored Car Transit Risks`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'ACR',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ContractFrustrationNonPayment]: {
    id: 'contract-frustration-non-payment',
    title: $localize`:@@cob-CFP:Contract Frustration Non Payment`,
    icon: 'product_thin',
    color: 'red',
    code: 'CFP',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ContractorsAllRisks]: {
    id: 'contractors-all-risks',
    title: $localize`:@@cob-316:Contractors All Risks`,
    icon: 'product_thin',
    color: 'green',
    code: '316',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
  [MexicoPncClassOfBusinessId.ErectionAllRisks]: {
    id: 'erection-all-risks',
    title: $localize`:@@cob-12:Erection All Risks`,
    icon: 'product_thin',
    color: 'orange',
    code: '12',
    type: 'policy',
    misc: {
      department: 'Mexico P&C',
      country: 'Mexico',
      countryCode: 'MEX',
    },
  },
};

export const PERU_PEOPLE_SOLUTIONS_COB_META_DATA: Record<
  PeruPeopleSolutionsClassOfBusinessId,
  CobMeta
> = {
  [PeruPeopleSolutionsClassOfBusinessId.PersonalAccident]: {
    id: 'personal-accident',
    title: $localize`:@@cob-454:Personal Accident`,
    icon: 'product_thin',
    color: 'green',
    code: '454',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.PrivateMedicalInsurance]: {
    id: 'private-medical-insurance',
    title: $localize`:@@cob-625:Private Medical Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '625',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.GroupCriticalIllness]: {
    id: 'group-critical-illness',
    title: $localize`:@@cob-699:Group Critical Illness`,
    icon: 'product_thin',
    color: 'orange',
    code: '699',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.WorkersCompensation]: {
    id: 'workers-compensation',
    title: $localize`:@@cob-WCA:Workers Compensation`,
    icon: 'product_thin',
    color: 'green',
    code: 'WCA',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.GroupLifeAssurance]: {
    id: 'group-life-assurance',
    title: $localize`:@@cob-640:Group Life Assurance`,
    icon: 'product_thin',
    color: 'red',
    code: '640',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.GroupPersonalAccident]: {
    id: 'group-personal-accident',
    title: $localize`:@@cob-452:Group Personal Accident`,
    icon: 'product_thin',
    color: 'red',
    code: '452',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.TravelLeisureBenefits]: {
    id: 'travel-leisure-benefits',
    title: $localize`:@@cob-727:Travel Leisure (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '727',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.NonAdvicePensionsConsultancy]: {
    id: 'non-advice-pensions-consultancy',
    title: $localize`:@@cob-598:Non-Advice Pensions Consultancy`,
    icon: 'product_thin',
    color: 'red',
    code: '598',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.TravelBusinessBenefits]: {
    id: 'travel-business-benefits',
    title: $localize`:@@cob-728:Travel Business (Benefits)`,
    icon: 'product_thin',
    color: 'pink',
    code: '728',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.GroupIncomeProtection]: {
    id: 'group-income-protection',
    title: $localize`:@@cob-262:Group Income Protection`,
    icon: 'product_thin',
    color: 'yellow',
    code: '262',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.Dental]: {
    id: 'dental',
    title: $localize`:@@cob-602:Dental`,
    icon: 'product_thin',
    color: 'blue',
    code: '602',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.Pharmacists]: {
    id: 'pharmacists',
    title: $localize`:@@cob-441:Pharmacists`,
    icon: 'product_thin',
    color: 'green',
    code: '441',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.CommunicationsBenefits]: {
    id: 'communications-benefits',
    title: $localize`:@@cob-446:Communications (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '446',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
  [PeruPeopleSolutionsClassOfBusinessId.PersonalAccidentTravel]: {
    id: 'personal-accident-travel',
    title: $localize`:@@cob-456:Personal Accident & Travel`,
    icon: 'product_thin',
    color: 'green',
    code: '456',
    type: 'policy',
    misc: {
      department: 'Peru People Solutions',
      country: 'Peru',
      countryCode: 'PER',
    },
  },
};

export const PERU_PNC_COB_META_DATA: Record<PeruPncClassOfBusinessId, CobMeta> =
  {
    [PeruPncClassOfBusinessId.BankersBlanketBond]: {
      id: 'bankers-blanket-bond',
      title: $localize`:@@cob-BBB:Bankers Blanket Bond`,
      icon: 'product_thin',
      color: 'blue',
      code: 'BBB',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.FidelityGuaranteeEmployee]: {
      id: 'fidelity-guarantee-employee',
      title: $localize`:@@cob-402:Fidelity Guarantee Employee`,
      icon: 'product_thin',
      color: 'orange',
      code: '402',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.AircraftHull]: {
      id: 'aircraft-hull',
      title: $localize`:@@cob-501:Aircraft Hull`,
      icon: 'product_thin',
      color: 'yellow',
      code: '501',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MotorLiability]: {
      id: 'motor-liability',
      title: $localize`:@@cob-11:Motor Liability`,
      icon: 'product_thin',
      color: 'blue',
      code: '11',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MarineHull]: {
      id: 'marine-hull',
      title: $localize`:@@cob-530:Marine Hull`,
      icon: 'product_thin',
      color: 'pink',
      code: '530',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Bonds]: {
      id: 'bonds',
      title: $localize`:@@cob-404:Bonds`,
      icon: 'product_thin',
      color: 'red',
      code: '404',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.CyberLiability]: {
      id: 'cyber-liability',
      title: $localize`:@@cob-183:Cyber Liability`,
      icon: 'product_thin',
      color: 'blue',
      code: '183',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ContractFrustrationNonPayment]: {
      id: 'contract-frustration-non-payment',
      title: $localize`:@@cob-CFP:Contract Frustration Non Payment`,
      icon: 'product_thin',
      color: 'red',
      code: 'CFP',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.HomeAndMotorPortfolio]: {
      id: 'home-and-motor-portfolio',
      title: $localize`:@@cob-289:Home and Motor Portfolio`,
      icon: 'product_thin',
      color: 'pink',
      code: '289',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Fee]: {
      id: 'fee',
      title: $localize`:@@cob-102:Fee`,
      icon: 'product_thin',
      color: 'orange',
      code: '102',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Fire]: {
      id: 'fire',
      title: $localize`:@@cob-569:FIRE`,
      icon: 'product_thin',
      color: 'blue',
      code: '569',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.CommercialCombined]: {
      id: 'commercial-combined',
      title: $localize`:@@cob-301:Commercial Combined`,
      icon: 'product_thin',
      color: 'pink',
      code: '301',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.PublicProductsLiability]: {
      id: 'public-products-liability',
      title: $localize`:@@cob-112:Public & Products Liability`,
      icon: 'product_thin',
      color: 'red',
      code: '112',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Crime]: {
      id: 'crime',
      title: $localize`:@@cob-410:Crime`,
      icon: 'product_thin',
      color: 'red',
      code: '410',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ContractorsAllRisks]: {
      id: 'contractors-all-risks',
      title: $localize`:@@cob-316:Contractors All Risks`,
      icon: 'product_thin',
      color: 'green',
      code: '316',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Computers]: {
      id: 'computers',
      title: $localize`:@@cob-303:Computers`,
      icon: 'product_thin',
      color: 'blue',
      code: '303',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ErectionAllRisks]: {
      id: 'erection-all-risks',
      title: $localize`:@@cob-12:Erection All Risks`,
      icon: 'product_thin',
      color: 'orange',
      code: '12',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Cargo]: {
      id: 'cargo',
      title: $localize`:@@cob-529:Cargo`,
      icon: 'product_thin',
      color: 'blue',
      code: '529',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MotorPrivateCar]: {
      id: 'motor-private-car',
      title: $localize`:@@cob-251:Motor Private Car`,
      icon: 'product_thin',
      color: 'red',
      code: '251',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.AviationLiability]: {
      id: 'aviation-liability',
      title: $localize`:@@cob-503:Aviation Liability`,
      icon: 'product_thin',
      color: 'red',
      code: '503',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.TradeCreditInsurance]: {
      id: 'trade-credit-insurance',
      title: $localize`:@@cob-403:Trade Credit Insurance`,
      icon: 'product_thin',
      color: 'green',
      code: '403',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.AgriculturalProperty]: {
      id: 'agricultural-property',
      title: $localize`:@@cob-344:Agricultural Property`,
      icon: 'product_thin',
      color: 'red',
      code: '344',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Motorcycle]: {
      id: 'motorcycle',
      title: $localize`:@@cob-252:Motorcycle`,
      icon: 'product_thin',
      color: 'yellow',
      code: '252',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MedicalMalpractice]: {
      id: 'medical-malpractice',
      title: $localize`:@@cob-169:Medical Malpractice`,
      icon: 'product_thin',
      color: 'blue',
      code: '169',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ProfessionalIndemnityEO]: {
      id: 'professional-indemnity-e-o',
      title: $localize`:@@cob-175:Professional Indemnity E&O`,
      icon: 'product_thin',
      color: 'blue',
      code: '175',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.PropertyOwnersLiability]: {
      id: 'property-owners-liability',
      title: $localize`:@@cob-155:Property Owners Liability`,
      icon: 'product_thin',
      color: 'orange',
      code: '155',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MaterialDamageAndBusinessInt]: {
      id: 'material-damage-and-business-int',
      title: $localize`:@@cob-333:Material Damage and Business Int`,
      icon: 'product_thin',
      color: 'orange',
      code: '333',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ConstructionCombined]: {
      id: 'construction-combined',
      title: $localize`:@@cob-577:Construction Combined`,
      icon: 'product_thin',
      color: 'blue',
      code: '577',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.EquipmentPhysicalDamage]: {
      id: 'equipment-physical-damage',
      title: $localize`:@@cob-219:Equipment Physical Damage`,
      icon: 'product_thin',
      color: 'red',
      code: '219',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.FineArtsInsurance]: {
      id: 'fine-arts-insurance',
      title: $localize`:@@cob-911:Fine Arts Insurance`,
      icon: 'product_thin',
      color: 'blue',
      code: '911',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.EventInsurance]: {
      id: 'event-insurance',
      title: $localize`:@@cob-415:Event Insurance`,
      icon: 'product_thin',
      color: 'blue',
      code: '415',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Terrorism]: {
      id: 'terrorism',
      title: $localize`:@@cob-307:Terrorism`,
      icon: 'product_thin',
      color: 'yellow',
      code: '307',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.PropertyDamage]: {
      id: 'property-damage',
      title: $localize`:@@cob-5:Property Damage`,
      icon: 'product_thin',
      color: 'red',
      code: '5',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.CombinedLiability]: {
      id: 'combined-liability',
      title: $localize`:@@cob-116:Combined Liability`,
      icon: 'product_thin',
      color: 'blue',
      code: '116',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.DirectorsOfficersLiability]: {
      id: 'directors-officers-liability',
      title: $localize`:@@cob-117:Directors & Officers Liability`,
      icon: 'product_thin',
      color: 'pink',
      code: '117',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.EnvironmentalImpairmentLiab]: {
      id: 'environmental-impairment-liab',
      title: $localize`:@@cob-152:Environmental Impairment Liab`,
      icon: 'product_thin',
      color: 'red',
      code: '152',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.WarehouseKeepersLiability]: {
      id: 'warehouse-keepers-liability',
      title: $localize`:@@cob-389:Warehouse Keepers Liability`,
      icon: 'product_thin',
      color: 'pink',
      code: '389',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MarinaOperatorsLiability]: {
      id: 'marina-operators-liability',
      title: $localize`:@@cob-520:Marina Operators Liability`,
      icon: 'product_thin',
      color: 'blue',
      code: '520',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.EmployersLiability]: {
      id: 'employers-liability',
      title: $localize`:@@cob-111:Employers Liability`,
      icon: 'product_thin',
      color: 'green',
      code: '111',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MarineHullLiability]: {
      id: 'marine-hull-liability',
      title: $localize`:@@cob-523:Marine Hull & Liability`,
      icon: 'product_thin',
      color: 'red',
      code: '523',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ProductsLiability]: {
      id: 'products-liability',
      title: $localize`:@@cob-121:Products Liability`,
      icon: 'product_thin',
      color: 'green',
      code: '121',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ProfIndtyInsuranceBrokers]: {
      id: 'prof-indty-insurance-brokers',
      title: $localize`:@@cob-164:Prof Indty Insurance Brokers`,
      icon: 'product_thin',
      color: 'yellow',
      code: '164',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ProfIndtyFinancialServices]: {
      id: 'prof-indty-financial-services',
      title: $localize`:@@cob-184:Prof Indty Financial Services`,
      icon: 'product_thin',
      color: 'orange',
      code: '184',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ClinicalTrials]: {
      id: 'clinical-trials',
      title: $localize`:@@cob-139:Clinical Trials`,
      icon: 'product_thin',
      color: 'orange',
      code: '139',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ProfIndtyEngineers]: {
      id: 'prof-indty-engineers',
      title: $localize`:@@cob-167:Prof Indty Engineers`,
      icon: 'product_thin',
      color: 'green',
      code: '167',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MotorFleet]: {
      id: 'motor-fleet',
      title: $localize`:@@cob-203:Motor Fleet`,
      icon: 'product_thin',
      color: 'pink',
      code: '203',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MarineLiability]: {
      id: 'marine-liability',
      title: $localize`:@@cob-527:Marine Liability`,
      icon: 'product_thin',
      color: 'green',
      code: '527',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.FreightForwardersLiability]: {
      id: 'freight-forwarders-liability',
      title: $localize`:@@cob-552:Freight Forwarders Liability`,
      icon: 'product_thin',
      color: 'pink',
      code: '552',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ContractualFinancialLoss]: {
      id: 'contractual-financial-loss',
      title: $localize`:@@cob-432:Contractual Financial Loss`,
      icon: 'product_thin',
      color: 'orange',
      code: '432',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.LossOfAnticipatedRentalIncome]: {
      id: 'loss-of-anticipated-rental-income',
      title: $localize`:@@cob-360:Loss of Anticipated Rental Income`,
      icon: 'product_thin',
      color: 'yellow',
      code: '360',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Livestock]: {
      id: 'livestock',
      title: $localize`:@@cob-374:Livestock`,
      icon: 'product_thin',
      color: 'red',
      code: '374',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MarinePortPackage]: {
      id: 'marine-port-package',
      title: $localize`:@@cob-486:Marine Port Package`,
      icon: 'product_thin',
      color: 'pink',
      code: '486',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.AircraftHullWar]: {
      id: 'aircraft-hull-war',
      title: $localize`:@@cob-HUW:Aircraft Hull War`,
      icon: 'product_thin',
      color: 'green',
      code: 'HUW',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.AviationHangarKeepersLiability]: {
      id: 'aviation-hangar-keepers-liability',
      title: $localize`:@@cob-APH:Aviation Hangar keepers Liability`,
      icon: 'product_thin',
      color: 'red',
      code: 'APH',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.AirportLiability]: {
      id: 'airport-liability',
      title: $localize`:@@cob-ARE:Airport Liability`,
      icon: 'product_thin',
      color: 'blue',
      code: 'ARE',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.AssetAllRisk]: {
      id: 'asset-all-risk',
      title: $localize`:@@cob-334:Asset All Risk`,
      icon: 'product_thin',
      color: 'blue',
      code: '334',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.EnergyProperty]: {
      id: 'energy-property',
      title: $localize`:@@cob-ENPR:Energy Property`,
      icon: 'product_thin',
      color: 'pink',
      code: 'ENPR',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.EnergyLiability]: {
      id: 'energy-liability',
      title: $localize`:@@cob-TPL:Energy Liability`,
      icon: 'product_thin',
      color: 'yellow',
      code: 'TPL',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ProfIndtySolicitors]: {
      id: 'prof-indty-solicitors',
      title: $localize`:@@cob-125:Prof Indty Solicitors`,
      icon: 'product_thin',
      color: 'blue',
      code: '125',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.AircraftHullLiability]: {
      id: 'aircraft-hull-liability',
      title: $localize`:@@cob-AHL:Aircraft Hull & Liability`,
      icon: 'product_thin',
      color: 'orange',
      code: 'AHL',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ContractorsPlantAndEquipment]: {
      id: 'contractors-plant-and-equipment',
      title: $localize`:@@cob-393:Contractors Plant and Equipment`,
      icon: 'product_thin',
      color: 'blue',
      code: '393',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ExcessLiability]: {
      id: 'excess-liability',
      title: $localize`:@@cob-ELI:Excess Liability`,
      icon: 'product_thin',
      color: 'orange',
      code: 'ELI',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MotorCommercialVehicle]: {
      id: 'motor-commercial-vehicle',
      title: $localize`:@@cob-202:Motor Commercial Vehicle`,
      icon: 'product_thin',
      color: 'green',
      code: '202',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.MotorSpecialTypes]: {
      id: 'motor-special-types',
      title: $localize`:@@cob-210:Motor Special Types`,
      icon: 'product_thin',
      color: 'yellow',
      code: '210',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.PropertyOwnersCombined]: {
      id: 'property-owners-combined',
      title: $localize`:@@cob-306:Property Owners Combined`,
      icon: 'product_thin',
      color: 'blue',
      code: '306',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.EngineeringMachineryBreakdown]: {
      id: 'engineering-machinery-breakdown',
      title: $localize`:@@cob-328:Engineering Machinery Breakdown`,
      icon: 'product_thin',
      color: 'orange',
      code: '328',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.Engineering]: {
      id: 'engineering',
      title: $localize`:@@cob-305:Engineering`,
      icon: 'product_thin',
      color: 'yellow',
      code: '305',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
    [PeruPncClassOfBusinessId.ArmoredCarTransitRisks]: {
      id: 'armored-car-transit-risks',
      title: $localize`:@@cob-ACR:Armored Car Transit Risks`,
      icon: 'product_thin',
      color: 'yellow',
      code: 'ACR',
      type: 'policy',
      misc: {
        department: 'Peru P&C',
        country: 'Peru',
        countryCode: 'PER',
      },
    },
  };

export const URUGUAY_PEOPLE_SOLUTIONS_COB_META_DATA: Record<
  UruguayPeopleSolutionsClassOfBusinessId,
  CobMeta
> = {
  [UruguayPeopleSolutionsClassOfBusinessId.WorkersCompensation]: {
    id: 'workers-compensation',
    title: $localize`:@@cob-WCA:Workers Compensation`,
    icon: 'product_thin',
    color: 'green',
    code: 'WCA',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.PersonalAccident]: {
    id: 'personal-accident',
    title: $localize`:@@cob-454:Personal Accident`,
    icon: 'product_thin',
    color: 'green',
    code: '454',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.PrivateMedicalInsurance]: {
    id: 'private-medical-insurance',
    title: $localize`:@@cob-625:Private Medical Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '625',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.GroupLifeAssurance]: {
    id: 'group-life-assurance',
    title: $localize`:@@cob-640:Group Life Assurance`,
    icon: 'product_thin',
    color: 'red',
    code: '640',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.GroupPersonalAccident]: {
    id: 'group-personal-accident',
    title: $localize`:@@cob-452:Group Personal Accident`,
    icon: 'product_thin',
    color: 'red',
    code: '452',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.TravelLeisureBenefits]: {
    id: 'travel-leisure-benefits',
    title: $localize`:@@cob-727:Travel Leisure (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '727',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.NonAdvicePensionsConsultancy]: {
    id: 'non-advice-pensions-consultancy',
    title: $localize`:@@cob-598:Non-Advice Pensions Consultancy`,
    icon: 'product_thin',
    color: 'red',
    code: '598',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.TravelBusinessBenefits]: {
    id: 'travel-business-benefits',
    title: $localize`:@@cob-728:Travel Business (Benefits)`,
    icon: 'product_thin',
    color: 'pink',
    code: '728',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.GroupIncomeProtection]: {
    id: 'group-income-protection',
    title: $localize`:@@cob-262:Group Income Protection`,
    icon: 'product_thin',
    color: 'yellow',
    code: '262',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.Dental]: {
    id: 'dental',
    title: $localize`:@@cob-602:Dental`,
    icon: 'product_thin',
    color: 'blue',
    code: '602',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.Pharmacists]: {
    id: 'pharmacists',
    title: $localize`:@@cob-441:Pharmacists`,
    icon: 'product_thin',
    color: 'green',
    code: '441',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.GroupCriticalIllness]: {
    id: 'group-critical-illness',
    title: $localize`:@@cob-699:Group Critical Illness`,
    icon: 'product_thin',
    color: 'orange',
    code: '699',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.CommunicationsBenefits]: {
    id: 'communications-benefits',
    title: $localize`:@@cob-446:Communications (Benefits)`,
    icon: 'product_thin',
    color: 'orange',
    code: '446',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPeopleSolutionsClassOfBusinessId.PersonalAccidentTravel]: {
    id: 'personal-accident-travel',
    title: $localize`:@@cob-456:Personal Accident & Travel`,
    icon: 'product_thin',
    color: 'green',
    code: '456',
    type: 'policy',
    misc: {
      department: 'Uruguay People Solutions',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
};

export const URUGUAY_PNC_COB_META_DATA: Record<
  UruguayPncClassOfBusinessId,
  CobMeta
> = {
  [UruguayPncClassOfBusinessId.AgriculturalProperty]: {
    id: 'agricultural-property',
    title: $localize`:@@cob-344:Agricultural Property`,
    icon: 'product_thin',
    color: 'red',
    code: '344',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MarineHull]: {
    id: 'marine-hull',
    title: $localize`:@@cob-530:Marine Hull`,
    icon: 'product_thin',
    color: 'pink',
    code: '530',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.CommercialCombined]: {
    id: 'commercial-combined',
    title: $localize`:@@cob-301:Commercial Combined`,
    icon: 'product_thin',
    color: 'pink',
    code: '301',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.TradeCreditInsurance]: {
    id: 'trade-credit-insurance',
    title: $localize`:@@cob-403:Trade Credit Insurance`,
    icon: 'product_thin',
    color: 'green',
    code: '403',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Bonds]: {
    id: 'bonds',
    title: $localize`:@@cob-404:Bonds`,
    icon: 'product_thin',
    color: 'red',
    code: '404',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Fire]: {
    id: 'fire',
    title: $localize`:@@cob-569:FIRE`,
    icon: 'product_thin',
    color: 'blue',
    code: '569',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.PublicProductsLiability]: {
    id: 'public-products-liability',
    title: $localize`:@@cob-112:Public & Products Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '112',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MotorLiability]: {
    id: 'motor-liability',
    title: $localize`:@@cob-11:Motor Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '11',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Cargo]: {
    id: 'cargo',
    title: $localize`:@@cob-529:Cargo`,
    icon: 'product_thin',
    color: 'blue',
    code: '529',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MotorPrivateCar]: {
    id: 'motor-private-car',
    title: $localize`:@@cob-251:Motor Private Car`,
    icon: 'product_thin',
    color: 'red',
    code: '251',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.HomeAndMotorPortfolio]: {
    id: 'home-and-motor-portfolio',
    title: $localize`:@@cob-289:Home and Motor Portfolio`,
    icon: 'product_thin',
    color: 'pink',
    code: '289',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.AviationLiability]: {
    id: 'aviation-liability',
    title: $localize`:@@cob-503:Aviation Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '503',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.FidelityGuaranteeEmployee]: {
    id: 'fidelity-guarantee-employee',
    title: $localize`:@@cob-402:Fidelity Guarantee Employee`,
    icon: 'product_thin',
    color: 'orange',
    code: '402',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Motorcycle]: {
    id: 'motorcycle',
    title: $localize`:@@cob-252:Motorcycle`,
    icon: 'product_thin',
    color: 'yellow',
    code: '252',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MedicalMalpractice]: {
    id: 'medical-malpractice',
    title: $localize`:@@cob-169:Medical Malpractice`,
    icon: 'product_thin',
    color: 'blue',
    code: '169',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ProfessionalIndemnityEO]: {
    id: 'professional-indemnity-e-o',
    title: $localize`:@@cob-175:Professional Indemnity E&O`,
    icon: 'product_thin',
    color: 'blue',
    code: '175',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.PropertyOwnersLiability]: {
    id: 'property-owners-liability',
    title: $localize`:@@cob-155:Property Owners Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: '155',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Crime]: {
    id: 'crime',
    title: $localize`:@@cob-410:Crime`,
    icon: 'product_thin',
    color: 'red',
    code: '410',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Computers]: {
    id: 'computers',
    title: $localize`:@@cob-303:Computers`,
    icon: 'product_thin',
    color: 'blue',
    code: '303',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MaterialDamageAndBusinessInt]: {
    id: 'material-damage-and-business-int',
    title: $localize`:@@cob-333:Material Damage and Business Int`,
    icon: 'product_thin',
    color: 'orange',
    code: '333',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.BankersBlanketBond]: {
    id: 'bankers-blanket-bond',
    title: $localize`:@@cob-BBB:Bankers Blanket Bond`,
    icon: 'product_thin',
    color: 'blue',
    code: 'BBB',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ConstructionCombined]: {
    id: 'construction-combined',
    title: $localize`:@@cob-577:Construction Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '577',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.EquipmentPhysicalDamage]: {
    id: 'equipment-physical-damage',
    title: $localize`:@@cob-219:Equipment Physical Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '219',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.FineArtsInsurance]: {
    id: 'fine-arts-insurance',
    title: $localize`:@@cob-911:Fine Arts Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '911',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.EventInsurance]: {
    id: 'event-insurance',
    title: $localize`:@@cob-415:Event Insurance`,
    icon: 'product_thin',
    color: 'blue',
    code: '415',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Terrorism]: {
    id: 'terrorism',
    title: $localize`:@@cob-307:Terrorism`,
    icon: 'product_thin',
    color: 'yellow',
    code: '307',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.PropertyDamage]: {
    id: 'property-damage',
    title: $localize`:@@cob-5:Property Damage`,
    icon: 'product_thin',
    color: 'red',
    code: '5',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.CombinedLiability]: {
    id: 'combined-liability',
    title: $localize`:@@cob-116:Combined Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '116',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.DirectorsOfficersLiability]: {
    id: 'directors-officers-liability',
    title: $localize`:@@cob-117:Directors & Officers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '117',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.EnvironmentalImpairmentLiab]: {
    id: 'environmental-impairment-liab',
    title: $localize`:@@cob-152:Environmental Impairment Liab`,
    icon: 'product_thin',
    color: 'red',
    code: '152',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.CyberLiability]: {
    id: 'cyber-liability',
    title: $localize`:@@cob-183:Cyber Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '183',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.WarehouseKeepersLiability]: {
    id: 'warehouse-keepers-liability',
    title: $localize`:@@cob-389:Warehouse Keepers Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '389',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MarinaOperatorsLiability]: {
    id: 'marina-operators-liability',
    title: $localize`:@@cob-520:Marina Operators Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: '520',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.EmployersLiability]: {
    id: 'employers-liability',
    title: $localize`:@@cob-111:Employers Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '111',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MarineHullLiability]: {
    id: 'marine-hull-liability',
    title: $localize`:@@cob-523:Marine Hull & Liability`,
    icon: 'product_thin',
    color: 'red',
    code: '523',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ProductsLiability]: {
    id: 'products-liability',
    title: $localize`:@@cob-121:Products Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '121',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ProfIndtyInsuranceBrokers]: {
    id: 'prof-indty-insurance-brokers',
    title: $localize`:@@cob-164:Prof Indty Insurance Brokers`,
    icon: 'product_thin',
    color: 'yellow',
    code: '164',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ProfIndtyFinancialServices]: {
    id: 'prof-indty-financial-services',
    title: $localize`:@@cob-184:Prof Indty Financial Services`,
    icon: 'product_thin',
    color: 'orange',
    code: '184',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ClinicalTrials]: {
    id: 'clinical-trials',
    title: $localize`:@@cob-139:Clinical Trials`,
    icon: 'product_thin',
    color: 'orange',
    code: '139',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ProfIndtyEngineers]: {
    id: 'prof-indty-engineers',
    title: $localize`:@@cob-167:Prof Indty Engineers`,
    icon: 'product_thin',
    color: 'green',
    code: '167',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MotorFleet]: {
    id: 'motor-fleet',
    title: $localize`:@@cob-203:Motor Fleet`,
    icon: 'product_thin',
    color: 'pink',
    code: '203',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MarineLiability]: {
    id: 'marine-liability',
    title: $localize`:@@cob-527:Marine Liability`,
    icon: 'product_thin',
    color: 'green',
    code: '527',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.FreightForwardersLiability]: {
    id: 'freight-forwarders-liability',
    title: $localize`:@@cob-552:Freight Forwarders Liability`,
    icon: 'product_thin',
    color: 'pink',
    code: '552',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ContractualFinancialLoss]: {
    id: 'contractual-financial-loss',
    title: $localize`:@@cob-432:Contractual Financial Loss`,
    icon: 'product_thin',
    color: 'orange',
    code: '432',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.LossOfAnticipatedRentalIncome]: {
    id: 'loss-of-anticipated-rental-income',
    title: $localize`:@@cob-360:Loss of Anticipated Rental Income`,
    icon: 'product_thin',
    color: 'yellow',
    code: '360',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Livestock]: {
    id: 'livestock',
    title: $localize`:@@cob-374:Livestock`,
    icon: 'product_thin',
    color: 'red',
    code: '374',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MarinePortPackage]: {
    id: 'marine-port-package',
    title: $localize`:@@cob-486:Marine Port Package`,
    icon: 'product_thin',
    color: 'pink',
    code: '486',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.AircraftHull]: {
    id: 'aircraft-hull',
    title: $localize`:@@cob-501:Aircraft Hull`,
    icon: 'product_thin',
    color: 'yellow',
    code: '501',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.AircraftHullWar]: {
    id: 'aircraft-hull-war',
    title: $localize`:@@cob-HUW:Aircraft Hull War`,
    icon: 'product_thin',
    color: 'green',
    code: 'HUW',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.AviationHangarKeepersLiability]: {
    id: 'aviation-hangar-keepers-liability',
    title: $localize`:@@cob-APH:Aviation Hangar keepers Liability`,
    icon: 'product_thin',
    color: 'red',
    code: 'APH',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.AirportLiability]: {
    id: 'airport-liability',
    title: $localize`:@@cob-ARE:Airport Liability`,
    icon: 'product_thin',
    color: 'blue',
    code: 'ARE',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.AssetAllRisk]: {
    id: 'asset-all-risk',
    title: $localize`:@@cob-334:Asset All Risk`,
    icon: 'product_thin',
    color: 'blue',
    code: '334',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.EnergyProperty]: {
    id: 'energy-property',
    title: $localize`:@@cob-ENPR:Energy Property`,
    icon: 'product_thin',
    color: 'pink',
    code: 'ENPR',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.EnergyLiability]: {
    id: 'energy-liability',
    title: $localize`:@@cob-TPL:Energy Liability`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'TPL',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ProfIndtySolicitors]: {
    id: 'prof-indty-solicitors',
    title: $localize`:@@cob-125:Prof Indty Solicitors`,
    icon: 'product_thin',
    color: 'blue',
    code: '125',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Fee]: {
    id: 'fee',
    title: $localize`:@@cob-102:Fee`,
    icon: 'product_thin',
    color: 'orange',
    code: '102',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.AircraftHullLiability]: {
    id: 'aircraft-hull-liability',
    title: $localize`:@@cob-AHL:Aircraft Hull & Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'AHL',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ContractorsPlantAndEquipment]: {
    id: 'contractors-plant-and-equipment',
    title: $localize`:@@cob-393:Contractors Plant and Equipment`,
    icon: 'product_thin',
    color: 'blue',
    code: '393',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ExcessLiability]: {
    id: 'excess-liability',
    title: $localize`:@@cob-ELI:Excess Liability`,
    icon: 'product_thin',
    color: 'orange',
    code: 'ELI',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MotorCommercialVehicle]: {
    id: 'motor-commercial-vehicle',
    title: $localize`:@@cob-202:Motor Commercial Vehicle`,
    icon: 'product_thin',
    color: 'green',
    code: '202',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.MotorSpecialTypes]: {
    id: 'motor-special-types',
    title: $localize`:@@cob-210:Motor Special Types`,
    icon: 'product_thin',
    color: 'yellow',
    code: '210',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.PropertyOwnersCombined]: {
    id: 'property-owners-combined',
    title: $localize`:@@cob-306:Property Owners Combined`,
    icon: 'product_thin',
    color: 'blue',
    code: '306',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.EngineeringMachineryBreakdown]: {
    id: 'engineering-machinery-breakdown',
    title: $localize`:@@cob-328:Engineering Machinery Breakdown`,
    icon: 'product_thin',
    color: 'orange',
    code: '328',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.Engineering]: {
    id: 'engineering',
    title: $localize`:@@cob-305:Engineering`,
    icon: 'product_thin',
    color: 'yellow',
    code: '305',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ArmoredCarTransitRisks]: {
    id: 'armored-car-transit-risks',
    title: $localize`:@@cob-ACR:Armored Car Transit Risks`,
    icon: 'product_thin',
    color: 'yellow',
    code: 'ACR',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ContractFrustrationNonPayment]: {
    id: 'contract-frustration-non-payment',
    title: $localize`:@@cob-CFP:Contract Frustration Non Payment`,
    icon: 'product_thin',
    color: 'red',
    code: 'CFP',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ContractorsAllRisks]: {
    id: 'contractors-all-risks',
    title: $localize`:@@cob-316:Contractors All Risks`,
    icon: 'product_thin',
    color: 'green',
    code: '316',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
  [UruguayPncClassOfBusinessId.ErectionAllRisks]: {
    id: 'erection-all-risks',
    title: $localize`:@@cob-12:Erection All Risks`,
    icon: 'product_thin',
    color: 'orange',
    code: '12',
    type: 'policy',
    misc: {
      department: 'Uruguay P&C',
      country: 'Uruguay',
      countryCode: 'URY',
    },
  },
};

export const COB_META_DATA_LATAM: Record<ClassOfBusinessId, CobMeta> = defaults(
  ARGENTINA_PEOPLE_SOLUTIONS_COB_META_DATA,
  ARGENTINA_PNC_COB_META_DATA,
  BRAZIL_PEOPLE_SOLUTIONS_COB_META_DATA,
  BRAZIL_PNC_COB_META_DATA,
  CHILE_PEOPLE_SOLUTIONS_COB_META_DATA,
  CHILE_PNC_COB_META_DATA,
  COLOMBIA_PEOPLE_SOLUTIONS_COB_META_DATA,
  COLOMBIA_PNC_COB_META_DATA,
  MEXICO_PEOPLE_SOLUTIONS_COB_META_DATA,
  MEXICO_PNC_COB_META_DATA,
  PERU_PEOPLE_SOLUTIONS_COB_META_DATA,
  PERU_PNC_COB_META_DATA,
  URUGUAY_PEOPLE_SOLUTIONS_COB_META_DATA,
  URUGUAY_PNC_COB_META_DATA
);
